/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* global moment:false */

	'use strict';

	var _configsGeneralConfig = __webpack_require__(1);

	var _configsRoutesConfig = __webpack_require__(2);

	var _configsGeneralRun = __webpack_require__(3);

	var _configsRestangularConfig = __webpack_require__(4);

	var _constantsIcons = __webpack_require__(5);

	/* Services Import */

	var _servicesUserLoginService = __webpack_require__(6);

	var _servicesLocalStorageLocalStorageService = __webpack_require__(7);

	var _servicesSitesSitesService = __webpack_require__(8);

	var _servicesGridGridService = __webpack_require__(9);

	var _servicesSupplierSupplierService = __webpack_require__(10);

	var _servicesAgencyAgencyService = __webpack_require__(11);

	var _servicesUserUserService = __webpack_require__(12);

	var _servicesCustomerCustomerService = __webpack_require__(13);

	var _servicesHistoryLogHistoryLogService = __webpack_require__(14);

	var _servicesSatisfactionSurveySatisfactionSurveyService = __webpack_require__(15);

	var _servicesCockpitCockpitService = __webpack_require__(16);

	var _servicesCreateFileCreateFileService = __webpack_require__(17);

	/* Controller Import */

	var _viewsMainMainController = __webpack_require__(18);

	var _viewsLoginLoginController = __webpack_require__(19);

	var _viewsContentSidebarSidebarControllerJs = __webpack_require__(20);

	var _viewsContentDashboardDashboardController = __webpack_require__(21);

	var _viewsContentDashboardSitesSitesController = __webpack_require__(22);

	var _viewsContentDashboardSitesEditSiteEditSiteController = __webpack_require__(23);

	var _viewsContentDashboardSitesEditSiteCustomAreaCustomAreaController = __webpack_require__(24);

	var _viewsContentDashboardSitesTypeSitesTypeController = __webpack_require__(25);

	var _viewsContentDashboardSitesTypeEditDialogEditDialogController = __webpack_require__(26);

	var _viewsContentDashboardActionCorrectiveFormController = __webpack_require__(27);

	var _viewsContentDashboardGridGenericListController = __webpack_require__(28);

	var _viewsContentDashboardGridGenericFormController = __webpack_require__(29);

	var _viewsContentDashboardGridSharedListController = __webpack_require__(30);

	var _viewsContentDashboardGridSharedFormController = __webpack_require__(31);

	var _viewsContentDashboardGridCustomListController = __webpack_require__(32);

	var _viewsContentDashboardGridCustomFormController = __webpack_require__(33);

	var _viewsContentDashboardGridDraftListController = __webpack_require__(34);

	var _viewsContentDashboardGridDraftFormController = __webpack_require__(35);

	var _viewsContentDashboardSupplierSupplierController = __webpack_require__(36);

	var _viewsContentDashboardSupplierEditSupplierEditSupplierController = __webpack_require__(37);

	var _viewsContentRightManagmentRightManagmentController = __webpack_require__(38);

	var _viewsContentRightManagmentUsersUsersController = __webpack_require__(39);

	var _viewsContentRightManagmentCustomersSpecificCustomersSpecificController = __webpack_require__(40);

	var _viewsContentRightManagmentUsersEditUserRoleEditUserRoleController = __webpack_require__(41);

	var _viewsContentRightManagmentCustomersCustomersController = __webpack_require__(42);

	var _viewsContentHistoryLogHistoryLogController = __webpack_require__(43);

	var _viewsContentSatisfactionSurveySatisfactionSurveyController = __webpack_require__(44);

	var _viewsContentSatisfactionSurveySeeAllSeeAllController = __webpack_require__(45);

	var _viewsContentSatisfactionSurveySeeAllCreateSurveyCreateSurveyController = __webpack_require__(46);

	var _viewsContentSatisfactionSurveySeeAllCreateQuestionCreateQuestionController = __webpack_require__(47);

	var _viewsContentSatisfactionSurveySeeAllEditQuestionEditQuestionController = __webpack_require__(48);

	var _viewsContentSatisfactionSurveySeeAnswerSeeAnswerController = __webpack_require__(49);

	var _viewsContentCockpitCockpitController = __webpack_require__(52);

	var _viewsContentCockpitFormDialogFormDialogController = __webpack_require__(53);

	var _componentsMdPaginationMdPaginationController = __webpack_require__(54);

	var _componentsGridListController = __webpack_require__(55);

	var _componentsGridFormController = __webpack_require__(56);

	var _componentsGridAffectationsController = __webpack_require__(57);

	var _componentsGridElementsController = __webpack_require__(58);

	var _componentsGridListsController = __webpack_require__(59);

	/* Directives Import */

	var _componentsUserInfosUserInfosDirective = __webpack_require__(60);

	var _componentsMdPaginationMdPaginationDirective = __webpack_require__(61);

	/* Components Import */

	var _componentsGridListComponent = __webpack_require__(62);

	var _componentsGridFormComponent = __webpack_require__(63);

	var _viewsContentRightManagmentUsersEditUserSecondaryAgenciesEditUserSecondaryAgenciesController = __webpack_require__(64);

	var _servicesCustomerSpecificCustomerSpecificService = __webpack_require__(65);

	var _viewsContentRightManagmentCustomersSpecificCustomerSpecificFormCustomerSpecificFormController = __webpack_require__(66);

	var _viewsContentRightManagmentCustomersSpecificEditCustomerSpecificSiteEditCustomerSpecificSiteController = __webpack_require__(67);

	var _viewsContentPopinsDefaultPopInController = __webpack_require__(68);

	var _viewsContentRightManagmentUsersEditManagerPlanningsAccessEditManagerPlanningsAccessController = __webpack_require__(69);

	var _servicesManagerManagerService = __webpack_require__(70);

	var _servicesControlControlService = __webpack_require__(71);

	var _viewsContentControlControlController = __webpack_require__(72);

	angular.module('agenorAdmin', ['ngAnimate', 'ngSanitize', 'ngMessages', 'restangular', 'ui.router', 'ngMaterial', 'md.data.table', 'toastr', 'LocalStorageModule', 'satellizer', 'ngFileUpload'])

	// Configurations
	.config(_configsGeneralConfig.config).config(_configsRoutesConfig.routerConfig).config(_configsRestangularConfig.restangularConfig)

	// Constant
	.constant('moment', moment).constant('icons', _constantsIcons.icons)

	// Run
	.run(_configsGeneralRun.run)

	//Services
	.service('LoginService', _servicesUserLoginService.LoginService).service('LocalStorage', _servicesLocalStorageLocalStorageService.LocalStorage).service('SiteService', _servicesSitesSitesService.SiteService).service('GridService', _servicesGridGridService.GridService).service('SupplierService', _servicesSupplierSupplierService.SupplierService).service('AgencyService', _servicesAgencyAgencyService.AgencyService).service('UserService', _servicesUserUserService.UserService).service('ManagerService', _servicesManagerManagerService.ManagerService).service('CustomerService', _servicesCustomerCustomerService.CustomerService).service('CustomerSpecificService', _servicesCustomerSpecificCustomerSpecificService.CustomerSpecificService).service('HistoryLogService', _servicesHistoryLogHistoryLogService.HistoryLogService).service('SatisfactionSurveyService', _servicesSatisfactionSurveySatisfactionSurveyService.SatisfactionSurveyService).service('CockpitService', _servicesCockpitCockpitService.CockpitService).service('CreateFileService', _servicesCreateFileCreateFileService.CreateFileService).service('ControlService', _servicesControlControlService.ControlService)

	// Controllers
	.controller('DefaultPopInController', _viewsContentPopinsDefaultPopInController.DefaultPopInController).controller('MainController', _viewsMainMainController.MainController).controller('LoginController', _viewsLoginLoginController.LoginController).controller('SidebarController', _viewsContentSidebarSidebarControllerJs.SidebarController).controller('DashboardController', _viewsContentDashboardDashboardController.DashboardController).controller('SitesController', _viewsContentDashboardSitesSitesController.SitesController).controller('EditSiteController', _viewsContentDashboardSitesEditSiteEditSiteController.EditSiteController).controller('EditDialogController', _viewsContentDashboardSitesTypeEditDialogEditDialogController.EditDialogController).controller('CustomAreaController', _viewsContentDashboardSitesEditSiteCustomAreaCustomAreaController.CustomAreaController).controller('SitesTypeController', _viewsContentDashboardSitesTypeSitesTypeController.SitesTypeController).controller('ActionCorrectiveFormController', _viewsContentDashboardActionCorrectiveFormController.ActionCorrectiveFormController).controller('SupplierController', _viewsContentDashboardSupplierSupplierController.SupplierController).controller('EditSupplierController', _viewsContentDashboardSupplierEditSupplierEditSupplierController.EditSupplierController).controller('RightManagmentController', _viewsContentRightManagmentRightManagmentController.RightManagmentController).controller('CustomersSpecificController', _viewsContentRightManagmentCustomersSpecificCustomersSpecificController.CustomersSpecificController).controller('CustomerSpecificFormController', _viewsContentRightManagmentCustomersSpecificCustomerSpecificFormCustomerSpecificFormController.CustomerSpecificFormController).controller('EditCustomerSpecificSiteController', _viewsContentRightManagmentCustomersSpecificEditCustomerSpecificSiteEditCustomerSpecificSiteController.EditCustomerSpecificSiteController).controller('HistoryLogController', _viewsContentHistoryLogHistoryLogController.HistoryLogController).controller('UsersController', _viewsContentRightManagmentUsersUsersController.UsersController).controller('EditUserRoleController', _viewsContentRightManagmentUsersEditUserRoleEditUserRoleController.EditUserRoleController).controller('EditUserSecondaryAgenciesController', _viewsContentRightManagmentUsersEditUserSecondaryAgenciesEditUserSecondaryAgenciesController.EditUserSecondaryAgenciesController).controller('EditManagerPlanningsAccessController', _viewsContentRightManagmentUsersEditManagerPlanningsAccessEditManagerPlanningsAccessController.EditManagerPlanningsAccessController).controller('CustomersController', _viewsContentRightManagmentCustomersCustomersController.CustomersController).controller('SatisfactionSurveyController', _viewsContentSatisfactionSurveySatisfactionSurveyController.SatisfactionSurveyController).controller('SeeAllController', _viewsContentSatisfactionSurveySeeAllSeeAllController.SeeAllController).controller('CreateSurveyController', _viewsContentSatisfactionSurveySeeAllCreateSurveyCreateSurveyController.CreateSurveyController).controller('CreateQuestionController', _viewsContentSatisfactionSurveySeeAllCreateQuestionCreateQuestionController.CreateQuestionController).controller('EditQuestionController', _viewsContentSatisfactionSurveySeeAllEditQuestionEditQuestionController.EditQuestionController).controller('SeeAnswerController', _viewsContentSatisfactionSurveySeeAnswerSeeAnswerController.SeeAnswerController).controller('CockpitController', _viewsContentCockpitCockpitController.CockpitController).controller('FormDialogController', _viewsContentCockpitFormDialogFormDialogController.FormDialogController).controller('ControlController', _viewsContentControlControlController.ControlController).controller('GenericGridListController', _viewsContentDashboardGridGenericListController.GenericGridListController).controller('GenericGridFormController', _viewsContentDashboardGridGenericFormController.GenericGridFormController).controller('SharedGridListController', _viewsContentDashboardGridSharedListController.SharedGridListController).controller('SharedGridFormController', _viewsContentDashboardGridSharedFormController.SharedGridFormController).controller('CustomGridListController', _viewsContentDashboardGridCustomListController.CustomGridListController).controller('CustomGridFormController', _viewsContentDashboardGridCustomFormController.CustomGridFormController).controller('DraftGridListController', _viewsContentDashboardGridDraftListController.DraftGridListController).controller('DraftGridFormController', _viewsContentDashboardGridDraftFormController.DraftGridFormController).controller('MdPaginationController', _componentsMdPaginationMdPaginationController.MdPaginationController).controller('GridListController', _componentsGridListController.GridListController).controller('GridFormController', _componentsGridFormController.GridFormController).controller('GridAffectationsController', _componentsGridAffectationsController.GridAffectationsController).controller('GridElementsController', _componentsGridElementsController.GridElementsController).controller('GridListsController', _componentsGridListsController.GridListsController)

	// Directives
	.directive('userInfos', _componentsUserInfosUserInfosDirective.UserInfosDirective).directive('mdPagination', _componentsMdPaginationMdPaginationDirective.MdPaginationDirective)

	// components
	.component('gridList', _componentsGridListComponent.GridList).component('gridForm', _componentsGridFormComponent.GridForm);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	config.$inject = ["$provide", "$logProvider", "appConfig", "toastrConfig", "moment", "localStorageServiceProvider", "$authProvider", "$mdDialogProvider"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.config = config;

	function config($provide, $logProvider, appConfig, toastrConfig, moment, localStorageServiceProvider, $authProvider, $mdDialogProvider) {
	    'ngInject';
	    // Enable log
	    $logProvider.debugEnabled(true);

	    // Set options third-party lib
	    toastrConfig.allowHtml = true;
	    toastrConfig.timeOut = 3000;
	    toastrConfig.positionClass = 'toast-top-right';
	    toastrConfig.preventDuplicates = false;
	    toastrConfig.progressBar = true;

	    $mdDialogProvider.addPreset('confirmModal', {
	        options: function options() {
	            return {
	                templateUrl: 'app/views/content/popins/defaultPopIn.html',
	                controller: 'DefaultPopInController',
	                controllerAs: 'dialog',
	                clickOutsideToClose: true,
	                escapeToClose: true
	            };
	        }
	    });

	    // Set localStorage configuration
	    localStorageServiceProvider.setPrefix('agecom').setStorageType('sessionStorage').setNotify(true, true);

	    // Set moment configuration
	    moment.locale('fr', {
	        months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
	        monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
	        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
	        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
	        weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
	        longDateFormat: {
	            LT: "HH:mm",
	            LTS: "HH:mm:ss",
	            L: "DD/MM/YYYY",
	            LL: "D MMMM YYYY",
	            LLL: "D MMMM YYYY LT",
	            LLLL: "dddd D MMMM YYYY LT"
	        } });

	    // Set Satellizer configuration
	    $authProvider.baseUrl = appConfig.apiBaseUrl;
	    $authProvider.tokenPrefix = 'agenor';

	    $authProvider.google({
	        clientId: appConfig.clientId,
	        //clientId: '229070875565-drlj41c6r1qltikn8sak2lfm54jl8e8h.apps.googleusercontent.com',
	        url: '/login/check-google',
	        //hd: 'ineat-conseil.fr',
	        redirectUri: appConfig.authentCallbackUrl
	        //requiredUrlParams: ['hd', 'scope']
	    });

	    // Set default use html template cache for angular material
	    $provide.decorator("$mdCompiler", ["$delegate", "$templateRequest", function ($delegate, $templateRequest) {
	        var _compile = $delegate.compile;
	        $delegate.compile = function (options) {
	            if (options) {
	                var templateUrl = options.templateUrl;
	                if (templateUrl) {
	                    delete options.templateUrl;
	                    options.template = $templateRequest(templateUrl);
	                }
	            }
	            return _compile.call(this, options);
	        };
	        return $delegate;
	    }]);
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	routerConfig.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.routerConfig = routerConfig;

	function routerConfig($stateProvider, $urlRouterProvider) {
	    'ngInject';

	    $stateProvider.state('root', {
	        url: '',
	        abstract: true,
	        templateUrl: 'app/views/main/main.html'
	    }).state('login', {
	        url: '/',
	        controller: 'LoginController',
	        controllerAs: 'login',
	        templateUrl: 'app/views/login/login.html'
	    }).state('root.view', {
	        abstract: true,
	        views: {
	            'sidebar@root': {
	                controller: 'SidebarController',
	                controllerAs: 'sidebar',
	                templateUrl: 'app/views/content/sidebar/sidebar.html'
	            }
	        }
	    }).state('root.view.dashboard', {
	        url: '/dashboard',
	        params: {
	            currentTab: null
	        },
	        views: {
	            'content@root': {
	                controller: 'DashboardController',
	                controllerAs: 'dashboard',
	                templateUrl: 'app/views/content/dashboard/dashboard.html'
	            },
	            'sites@root.view.dashboard': {
	                controller: 'SitesController',
	                controllerAs: 'sites',
	                templateUrl: 'app/views/content/dashboard/sites/sites.html'
	            },
	            'sitesType@root.view.dashboard': {
	                controller: 'SitesTypeController',
	                controllerAs: 'siteTypes',
	                templateUrl: 'app/views/content/dashboard/sitesType/sitesType.html'
	            },
	            'genericGrids@root.view.dashboard': {
	                templateUrl: 'app/views/content/dashboard/grid/generic/list.html',
	                controller: 'GenericGridListController',
	                controllerAs: 'ctrl'
	            },
	            'sharedGrids@root.view.dashboard': {
	                templateUrl: 'app/views/content/dashboard/grid/shared/list.html',
	                controller: 'SharedGridListController',
	                controllerAs: 'ctrl'
	            },
	            'customGrids@root.view.dashboard': {
	                templateUrl: 'app/views/content/dashboard/grid/custom/list.html',
	                controller: 'CustomGridListController',
	                controllerAs: 'ctrl'
	            },
	            'draftGrids@root.view.dashboard': {
	                templateUrl: 'app/views/content/dashboard/grid/draft/list.html',
	                controller: 'DraftGridListController',
	                controllerAs: 'ctrl'
	            },
	            'supplier@root.view.dashboard': {
	                controller: 'SupplierController',
	                controllerAs: 'supplier',
	                templateUrl: 'app/views/content/dashboard/supplier/supplier.html'
	            }
	        }
	    }).state('root.view.site', {
	        url: '/site/:id',
	        views: {
	            'content@root': {
	                controller: 'EditSiteController',
	                controllerAs: 'editSite',
	                templateUrl: 'app/views/content/dashboard/sites/editSite/editSite.html'
	            }
	        }
	    }).state('root.view.newGenericGrid', {
	        url: '/grid/generic/new/:from',
	        views: {
	            'content@root': {
	                controller: 'GenericGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/generic/form.html'
	            }
	        }
	    }).state('root.view.editGenericGrid', {
	        url: '/grid/generic/edit/:id/:from',
	        views: {
	            'content@root': {
	                controller: 'GenericGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/generic/form.html'
	            }
	        }
	    }).state('root.view.newSharedGrid', {
	        url: '/grid/shared/new/:from',
	        views: {
	            'content@root': {
	                controller: 'SharedGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/shared/form.html'
	            }
	        }
	    }).state('root.view.editSharedGrid', {
	        url: '/grid/shared/edit/:id/:from',
	        views: {
	            'content@root': {
	                controller: 'SharedGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/shared/form.html'
	            }
	        }
	    }).state('root.view.editCustomGrid', {
	        url: '/grid/custom/edit/:id/:from',
	        views: {
	            'content@root': {
	                controller: 'CustomGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/custom/form.html'
	            }
	        }
	    }).state('root.view.newDraftGrid', {
	        url: '/grid/draft/new/:from',
	        views: {
	            'content@root': {
	                controller: 'DraftGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/draft/form.html'
	            }
	        }
	    }).state('root.view.editDraftGrid', {
	        url: '/grid/draft/edit/:id/:from',
	        views: {
	            'content@root': {
	                controller: 'DraftGridFormController',
	                controllerAs: 'ctrl',
	                templateUrl: 'app/views/content/dashboard/grid/draft/form.html'
	            }
	        }
	    }).state('root.view.right', {
	        url: '/right-managment',
	        views: {
	            'content@root': {
	                controller: 'RightManagmentController',
	                controllerAs: 'right',
	                templateUrl: 'app/views/content/rightManagment/rightManagment.html'
	            },
	            'users@root.view.right': {
	                controller: 'UsersController',
	                controllerAs: 'users',
	                templateUrl: 'app/views/content/rightManagment/users/users.html'
	            },
	            'customers@root.view.right': {
	                controller: 'CustomersController',
	                controllerAs: 'customers',
	                templateUrl: 'app/views/content/rightManagment/customers/customers.html'
	            },
	            'customersSpecific@root.view.right': {
	                controller: 'CustomersSpecificController',
	                controllerAs: 'customersSpecific',
	                templateUrl: 'app/views/content/rightManagment/customersSpecific/customersSpecific.html'
	            }
	        }
	    }).state('root.view.historyLog', {
	        url: '/history-log',
	        views: {
	            'content@root': {
	                controller: 'HistoryLogController',
	                controllerAs: 'historyLogs',
	                templateUrl: 'app/views/content/historyLog/historyLog.html'
	            }
	        }
	    }).state('root.view.satisfactionSurvey', {
	        url: '/satisfaction-survey',
	        params: {
	            currentTab: null
	        },
	        views: {
	            'content@root': {
	                controller: 'SatisfactionSurveyController',
	                controllerAs: 'idk',
	                templateUrl: 'app/views/content/satisfactionSurvey/satisfactionSurvey.html'
	            },
	            'seeAll@root.view.satisfactionSurvey': {
	                controller: 'SeeAllController',
	                controllerAs: 'seeAlls',
	                templateUrl: 'app/views/content/satisfactionSurvey/seeAll/seeAll.html'
	            },
	            'seeAnswer@root.view.satisfactionSurvey': {
	                controller: 'SeeAnswerController',
	                controllerAs: 'seeAnswers',
	                templateUrl: 'app/views/content/satisfactionSurvey/seeAnswer/seeAnswer.html'
	            }
	        }
	    }).state('root.view.cockpit', {
	        url: '/cockpit',
	        views: {
	            'content@root': {
	                controller: 'CockpitController',
	                controllerAs: 'cockpit',
	                templateUrl: 'app/views/content/cockpit/cockpit.html'
	            }
	        },
	        requireAuth: true //This is for pages that do not call the webservice directly
	    }).state('root.view.control', {
	        url: '/control',
	        views: {
	            'content@root': {
	                controller: 'ControlController',
	                controllerAs: 'control',
	                templateUrl: 'app/views/content/control/control.html'
	            }
	        }
	    });

	    $urlRouterProvider.otherwise('/');
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	run.$inject = ["$log", "$rootScope", "$state", "toastr", "Restangular"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.run = run;

	function run($log, $rootScope, $state, toastr, Restangular) {
	    'ngInject';

	    var requestInProgress = 0;

	    //This is for pages that do not call the webservice directly
	    var deregistrationStateChange = $rootScope.$on('$stateChangeStart', function (event, next) {
	        if (localStorage.getItem('agenor_token') == null && next.requireAuth) {
	            event.preventDefault();
	            $state.go('login');
	            toastr.info('Votre session à expirée, merci de vous reconnecter');
	        }
	    });

	    Restangular.addRequestInterceptor(function (element) {
	        requestInProgress = requestInProgress + 1;
	        $rootScope.xhr = true;

	        return element;
	    });

	    Restangular.addResponseInterceptor(function (data) {
	        requestInProgress = requestInProgress - 1;
	        if (requestInProgress === 0) {
	            $rootScope.xhr = false;
	        }

	        return data;
	    });

	    Restangular.setErrorInterceptor(function (response) {
	        $log.debug(response);
	        if (response.status === 401 || response.status === 403) {
	            var msg = response.status === 403 ? 'Accès refusé. Droits insuffisants' : 'Votre session à expiré, merci de vous reconnecter';
	            requestInProgress = 0;
	            $rootScope.xhr = false;

	            localStorage.removeItem('agenor_token');
	            $state.go('login');
	            toastr.info(msg);

	            return false;
	        } else {
	            requestInProgress--;
	            if (requestInProgress === 0) {
	                $rootScope.xhr = false;
	            }
	        }

	        $rootScope.$on('$destroy', deregistrationStateChange);

	        return true; // error not handled
	    });
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	restangularConfig.$inject = ["appConfig", "RestangularProvider"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.restangularConfig = restangularConfig;

	function restangularConfig(appConfig, RestangularProvider) {
	    'ngInject';

	    RestangularProvider.setBaseUrl(appConfig.apiBaseUrl + '/api/');
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var icons = [{ id: 0, name: 'Autre ', src: 'assets/picto/template_icon_0.png' }, { id: 1, name: 'Bureau', src: 'assets/picto/template_icon_1.png' }, { id: 2, name: 'Circulations', src: 'assets/picto/template_icon_2.png' }, { id: 3, name: 'Toilettes', src: 'assets/picto/template_icon_3.png' }, { id: 4, name: 'Salle de réunion', src: 'assets/picto/template_icon_4.png' }, { id: 5, name: 'Réfectoire', src: 'assets/picto/template_icon_5.png' }, { id: 6, name: 'Parking', src: 'assets/picto/template_icon_6.png' }, { id: 7, name: 'Bibliothèque', src: 'assets/picto/template_icon_7.png' }, { id: 8, name: 'Bungalow de chantier', src: 'assets/picto/template_icon_8.png' }, { id: 10, name: 'Buvette', src: 'assets/picto/template_icon_10.png' }, { id: 11, name: 'Chambre d\'hotel', src: 'assets/picto/template_icon_11.png' }, { id: 12, name: 'Chambre froide', src: 'assets/picto/template_icon_12.png' }, { id: 13, name: 'Chaufferie', src: 'assets/picto/template_icon_13.png' }, { id: 14, name: 'Containers', src: 'assets/picto/template_icon_14.png' }, { id: 15, name: 'Container déchets', src: 'assets/picto/template_icon_15.png' }, { id: 16, name: 'Cuisine', src: 'assets/picto/template_icon_16.png' }, { id: 17, name: 'Dojo', src: 'assets/picto/template_icon_17.png' }, { id: 18, name: 'Dortoires', src: 'assets/picto/template_icon_18.png' }, { id: 19, name: 'Douche', src: 'assets/picto/template_icon_19.png' }, { id: 20, name: 'Encombrants Déchets', src: 'assets/picto/template_icon_20.png' }, { id: 21, name: 'Entrepot de stockage', src: 'assets/picto/template_icon_21.png' }, { id: 22, name: 'Escalator', src: 'assets/picto/template_icon_22.png' }, { id: 23, name: 'Espace de vente', src: 'assets/picto/template_icon_23.png' }, { id: 24, name: 'Espaces verts', src: 'assets/picto/template_icon_24.png' }, { id: 25, name: 'Fitness', src: 'assets/picto/template_icon_25.png' }, { id: 26, name: 'Gymnase', src: 'assets/picto/template_icon_26.png' }, { id: 27, name: 'Hall d\'accueil', src: 'assets/picto/template_icon_27.png' }, { id: 28, name: 'Hall d\'entrée', src: 'assets/picto/template_icon_28.png' }, { id: 29, name: 'Infirmerie', src: 'assets/picto/template_icon_29.png' }, { id: 30, name: 'Jacuzzi', src: 'assets/picto/template_icon_30.png' }, { id: 31, name: 'Labo', src: 'assets/picto/template_icon_31.png' }, { id: 32, name: 'Laverie', src: 'assets/picto/template_icon_32.png' }, { id: 33, name: 'Local matériel', src: 'assets/picto/template_icon_33.png' }, { id: 34, name: 'Local poubelle', src: 'assets/picto/template_icon_34.png' }, { id: 35, name: 'Local poussette', src: 'assets/picto/template_icon_35.png' }, { id: 36, name: 'Local vélo', src: 'assets/picto/template_icon_36.png' }, { id: 37, name: 'Local d\'entretien', src: 'assets/picto/template_icon_37.png' }, { id: 38, name: 'Loges', src: 'assets/picto/template_icon_38.png' }, { id: 39, name: 'Musculation', src: 'assets/picto/template_icon_39.png' }, { id: 40, name: 'Palier d\'ecalier', src: 'assets/picto/template_icon_40.png' }, { id: 41, name: 'Parking', src: 'assets/picto/template_icon_41.png' }, { id: 42, name: 'Peron', src: 'assets/picto/template_icon_42.png' }, { id: 43, name: 'Plage', src: 'assets/picto/template_icon_43.png' }, { id: 44, name: 'Réserve', src: 'assets/picto/template_icon_44.png' }, { id: 45, name: 'Salle des archives', src: 'assets/picto/template_icon_45.png' }, { id: 46, name: 'Salle de cours', src: 'assets/picto/template_icon_46.png' }, { id: 47, name: 'Jeux adulte', src: 'assets/picto/template_icon_47.png' }, { id: 48, name: 'Salle de pause', src: 'assets/picto/template_icon_48.png' }, { id: 49, name: 'Salle des machines', src: 'assets/picto/template_icon_49.png' }, { id: 50, name: 'Salle de sport', src: 'assets/picto/template_icon_50.png' }, { id: 51, name: 'Salle des profs', src: 'assets/picto/template_icon_51.png' }, { id: 52, name: 'Jeux enfant', src: 'assets/picto/template_icon_52.png' }, { id: 53, name: 'Sauna', src: 'assets/picto/template_icon_53.png' }, { id: 54, name: 'Solarium', src: 'assets/picto/template_icon_54.png' }, { id: 55, name: 'Sous-sol', src: 'assets/picto/template_icon_55.png' }, { id: 56, name: 'Stade', src: 'assets/picto/template_icon_56.png' }, { id: 57, name: 'Table à langer', src: 'assets/picto/template_icon_57.png' }, { id: 58, name: 'Terasse', src: 'assets/picto/template_icon_58.png' }, { id: 59, name: 'Tobogan', src: 'assets/picto/template_icon_59.png' }, { id: 60, name: 'Toiture', src: 'assets/picto/template_icon_60.png' }, { id: 61, name: 'Tribunes', src: 'assets/picto/template_icon_61.png' }, { id: 62, name: 'Vestiaires', src: 'assets/picto/template_icon_62.png' }, { id: 63, name: 'Vitrine', src: 'assets/picto/template_icon_63.png' }, { id: 64, name: 'Amphi', src: 'assets/picto/template_icon_64.png' }, { id: 65, name: 'Ascenseur', src: 'assets/picto/template_icon_65.png' }, { id: 66, name: 'Atelier', src: 'assets/picto/template_icon_66.png' }, { id: 67, name: 'Atelier danger', src: 'assets/picto/template_icon_67.png' }, { id: 68, name: 'Atelier réparation', src: 'assets/picto/template_icon_68.png' }, { id: 69, name: 'Balcon', src: 'assets/picto/template_icon_69.png' }, { id: 70, name: 'Bassin', src: 'assets/picto/template_icon_70.png' }, { id: 71, name: 'Bassin enfant', src: 'assets/picto/template_icon_71.png' }];
	exports.icons = icons;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var LoginService = function LoginService($log, $q, $timeout, Restangular, $http) {
	    'ngInject';

	    _classCallCheck(this, LoginService);

	    this.$log = $log;
	    this.$q = $q;
	    this.$timeout = $timeout;
	    this.restangular = Restangular;
	    this.$http = $http;
	};
	LoginService.$inject = ["$log", "$q", "$timeout", "Restangular", "$http"];

	exports.LoginService = LoginService;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var LocalStorage = (function () {
	    LocalStorage.$inject = ["$log", "localStorageService"];
	    function LocalStorage($log, localStorageService) {
	        'ngInject';

	        _classCallCheck(this, LocalStorage);

	        this.localStorageService = localStorageService;
	        this.$log = $log;
	    }

	    // services

	    _createClass(LocalStorage, [{
	        key: 'saveToLocalStorage',
	        value: function saveToLocalStorage(key, data) {
	            this.localStorageService.set(key, data);
	        }
	    }, {
	        key: 'readFromLocalStorage',
	        value: function readFromLocalStorage(key) {
	            return this.localStorageService.get(key);
	        }
	    }, {
	        key: 'clearLocalStorage',
	        value: function clearLocalStorage() {
	            return this.localStorageService.clearAll();
	        }
	    }]);

	    return LocalStorage;
	})();

	exports.LocalStorage = LocalStorage;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SiteService = (function () {
	    SiteService.$inject = ["$log", "$http", "$timeout", "Restangular"];
	    function SiteService($log, $http, $timeout, Restangular) {
	        'ngInject';

	        _classCallCheck(this, SiteService);

	        this.$log = $log;
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	    }

	    // services

	    // Site

	    _createClass(SiteService, [{
	        key: 'getSites',
	        value: function getSites() {
	            return this.restangular.one('sites').get();
	        }
	    }, {
	        key: 'getSite',
	        value: function getSite(id) {
	            return this.restangular.one('sites', id).get();
	        }
	    }, {
	        key: 'updateSite',
	        value: function updateSite(id, data) {
	            return this.restangular.one('sites', id).patch(data);
	        }
	    }, {
	        key: 'getSitesCount',
	        value: function getSitesCount() {
	            return this.restangular.one('sites').one('count').get();
	        }
	    }, {
	        key: 'searchSite',
	        value: function searchSite(query, option) {
	            var queryParams = {};
	            queryParams[option] = query;
	            return this.restangular.one('sites').one('search').get(queryParams);
	        }
	    }, {
	        key: 'getActiveSites',
	        value: function getActiveSites() {
	            return this.restangular.one('sites').one('active').get();
	        }

	        // Site Types
	    }, {
	        key: 'getSiteTypes',
	        value: function getSiteTypes() {
	            return this.restangular.one('sitetypes/').get();
	        }
	    }, {
	        key: 'addSiteType',
	        value: function addSiteType(data) {
	            return this.restangular.one('sitetypes/').post('', data);
	        }
	    }, {
	        key: 'editSiteType',
	        value: function editSiteType(id, data) {
	            return this.restangular.one('sitetypes', id).patch(data);
	        }
	    }, {
	        key: 'deleteSiteType',
	        value: function deleteSiteType(id) {
	            return this.restangular.one('sitetypes', id).remove();
	        }

	        // Site Area
	    }, {
	        key: 'getSiteArea',
	        value: function getSiteArea(id) {
	            return this.restangular.one('sites', id).one('areatemplates').get();
	        }
	    }, {
	        key: 'removeArea',
	        value: function removeArea() {
	            var data = { statusCode: 200 };
	            return this.$timeout(function () {
	                return data;
	            });
	        }
	    }, {
	        key: 'updateSiteArea',
	        value: function updateSiteArea(id, data) {
	            return this.restangular.one('areatemplates').one('site', id).post('', data);
	        }
	    }, {
	        key: 'updateCustomArea',
	        value: function updateCustomArea(id, data) {
	            return this.restangular.one('areatemplates').one('site', id).patch(data);
	        }

	        // Site Supplier
	    }, {
	        key: 'getSiteSuppliers',
	        value: function getSiteSuppliers(id) {
	            return this.restangular.one('sites', id).one('suppliers').get();
	        }
	    }]);

	    return SiteService;
	})();

	exports.SiteService = SiteService;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var GridService = (function () {
	    GridService.$inject = ["$log", "$http", "$timeout", "Restangular"];
	    function GridService($log, $http, $timeout, Restangular) {
	        'ngInject';

	        _classCallCheck(this, GridService);

	        this.$log = $log;
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	    }

	    // services

	    // common grids

	    _createClass(GridService, [{
	        key: 'getGrids',
	        value: function getGrids(type) {
	            return this.restangular.one('areatemplates/').get({ 'type': type });
	        }
	    }, {
	        key: 'getAreaTemplate',
	        value: function getAreaTemplate(id) {
	            return this.restangular.one('areatemplates/new', id).get();
	        }
	    }, {
	        key: 'removeAreaTemplate',
	        value: function removeAreaTemplate(id) {
	            return this.restangular.one('areatemplates', id).remove();
	        }
	    }, {
	        key: 'removeSiteAreaTemplate',
	        value: function removeSiteAreaTemplate(id) {
	            return this.restangular.one('areatemplates/remove', id).remove();
	        }
	    }, {
	        key: 'saveNewGrid',
	        value: function saveNewGrid(data) {
	            return this.restangular.one('areatemplates/').post('', data);
	        }
	    }, {
	        key: 'updateGrid',
	        value: function updateGrid(id, data) {
	            return this.restangular.one('areatemplates', id).patch(data);
	        }
	    }, {
	        key: 'getNewGrids',
	        value: function getNewGrids(type) {
	            return this.restangular.one('areatemplates/new').get({ 'type': type });
	        }
	    }]);

	    return GridService;
	})();

	exports.GridService = GridService;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SupplierService = (function () {
	    SupplierService.$inject = ["$log", "$http", "$timeout", "Restangular", "Upload", "appConfig"];
	    function SupplierService($log, $http, $timeout, Restangular, Upload, appConfig) {
	        'ngInject';

	        _classCallCheck(this, SupplierService);

	        this.$log = $log;
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	        this.Upload = Upload;
	        this.appConfig = appConfig;
	    }

	    // services

	    _createClass(SupplierService, [{
	        key: 'getSuppliers',
	        value: function getSuppliers() {
	            return this.restangular.one('suppliers/').get();
	        }
	    }, {
	        key: 'deleteSupplier',
	        value: function deleteSupplier(id) {
	            return this.restangular.one('suppliers', id).remove();
	        }
	    }, {
	        key: 'addSupplier',
	        value: function addSupplier(data, image) {
	            return this.Upload.upload({
	                url: this.appConfig.apiBaseUrl + '/api/suppliers/',
	                data: { logo: image, supplier: data }
	            });
	        }
	    }, {
	        key: 'updateSupplier',
	        value: function updateSupplier(id, data, image) {
	            return this.Upload.upload({
	                url: this.appConfig.apiBaseUrl + '/api/suppliers/' + id,
	                method: 'POST',
	                data: { logo: image, supplier: data }
	            });
	        }
	    }]);

	    return SupplierService;
	})();

	exports.SupplierService = SupplierService;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var AgencyService = (function () {
	    AgencyService.$inject = ["$log", "$http", "$timeout", "Restangular"];
	    function AgencyService($log, $http, $timeout, Restangular) {
	        'ngInject';

	        _classCallCheck(this, AgencyService);

	        this.$log = $log;
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	    }

	    // services

	    _createClass(AgencyService, [{
	        key: 'getAgencies',
	        value: function getAgencies() {
	            return this.restangular.one('agencies/').get();
	        }
	    }]);

	    return AgencyService;
	})();

	exports.AgencyService = AgencyService;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var UserService = (function () {
	    UserService.$inject = ["$log", "$q", "$timeout", "Restangular", "$http"];
	    function UserService($log, $q, $timeout, Restangular, $http) {
	        'ngInject';

	        _classCallCheck(this, UserService);

	        this.$log = $log;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	        this.$http = $http;
	    }

	    // services

	    _createClass(UserService, [{
	        key: 'getUsers',
	        value: function getUsers() {
	            return this.restangular.one('users/').get();
	        }
	    }, {
	        key: 'addUser',
	        value: function addUser(data) {
	            return this.restangular.one('users/').post('', data);
	        }
	    }, {
	        key: 'updateUser',
	        value: function updateUser(id, user) {
	            return this.restangular.one('users', id).patch(user);
	        }
	    }, {
	        key: 'deleteUser',
	        value: function deleteUser(id) {
	            return this.restangular.one('users', id).remove();
	        }
	    }, {
	        key: 'getRoles',
	        value: function getRoles() {
	            return this.restangular.one('users').one('roles').get();
	        }
	    }, {
	        key: 'getConnectedUserAgencies',
	        value: function getConnectedUserAgencies() {
	            return this.restangular.one('users').one('agencies').get();
	        }
	    }, {
	        key: 'getUserAgencies',
	        value: function getUserAgencies(id) {
	            return this.restangular.one('users', id).one('agencies').get();
	        }
	    }, {
	        key: 'getUserSecondaryAgencies',
	        value: function getUserSecondaryAgencies(id) {
	            return this.restangular.one('users', id).one('secondaryAgencies').get();
	        }
	    }]);

	    return UserService;
	})();

	exports.UserService = UserService;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomerService = (function () {
	    CustomerService.$inject = ["$log", "$q", "$timeout", "Restangular", "$http"];
	    function CustomerService($log, $q, $timeout, Restangular, $http) {
	        'ngInject';

	        _classCallCheck(this, CustomerService);

	        this.$log = $log;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	        this.$http = $http;
	    }

	    // services

	    _createClass(CustomerService, [{
	        key: 'getCustomers',
	        value: function getCustomers(page, limit) {
	            return this.restangular.one('customers/').get({ 'page': page, 'limit': limit });
	        }
	    }, {
	        key: 'getCustomerAnswers',
	        value: function getCustomerAnswers() {
	            return this.restangular.one('customers/dynamic_form_answers').get();
	        }
	    }, {
	        key: 'getCustomersCount',
	        value: function getCustomersCount() {
	            return this.restangular.one('customers').one('count').get();
	        }
	    }]);

	    return CustomerService;
	})();

	exports.CustomerService = CustomerService;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var HistoryLogService = (function () {
	    HistoryLogService.$inject = ["Restangular"];
	    function HistoryLogService(Restangular) {
	        'ngInject';

	        _classCallCheck(this, HistoryLogService);

	        this.restangular = Restangular;
	    }

	    // services

	    _createClass(HistoryLogService, [{
	        key: 'getQuadraLogs',
	        value: function getQuadraLogs() {
	            return this.restangular.one('synchroquadralogs/').get();
	        }
	    }]);

	    return HistoryLogService;
	})();

	exports.HistoryLogService = HistoryLogService;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SatisfactionSurveyService = (function () {
	  SatisfactionSurveyService.$inject = ["Restangular"];
	  function SatisfactionSurveyService(Restangular) {
	    'ngInject';

	    _classCallCheck(this, SatisfactionSurveyService);

	    this.restangular = Restangular;
	  }

	  // services

	  _createClass(SatisfactionSurveyService, [{
	    key: 'getLastActiveForm',
	    value: function getLastActiveForm() {
	      return this.restangular.one('survey/last-active').get();
	    }
	  }, {
	    key: 'getAllForms',
	    value: function getAllForms() {
	      return this.restangular.one('survey').get();
	    }
	  }, {
	    key: 'getSurveyById',
	    value: function getSurveyById(id) {
	      return this.restangular.one('survey/' + id).get();
	    }
	  }, {
	    key: 'removeSurvey',
	    value: function removeSurvey(id) {
	      return this.restangular.one('survey/' + id).remove();
	    }
	  }, {
	    key: 'getQuestionTypes',
	    value: function getQuestionTypes() {
	      return this.restangular.one('survey/question-types').get();
	    }
	  }, {
	    key: 'patchFormId',
	    value: function patchFormId(id, data) {
	      return this.restangular.one('survey/' + id).patch(data);
	    }
	  }, {
	    key: 'createForm',
	    value: function createForm(data) {
	      return this.restangular.one('survey').post('', data);
	    }
	  }, {
	    key: 'getAnswers',
	    value: function getAnswers(surveyId) {
	      return this.restangular.one('survey/' + surveyId + '/answers').get();
	    }
	  }]);

	  return SatisfactionSurveyService;
	})();

	exports.SatisfactionSurveyService = SatisfactionSurveyService;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CockpitService = (function () {
	    CockpitService.$inject = ["Restangular", "appConfig"];
	    function CockpitService(Restangular, appConfig) {
	        'ngInject';

	        _classCallCheck(this, CockpitService);

	        this.appConfig = appConfig;
	        this.restangular = Restangular;
	    }

	    _createClass(CockpitService, [{
	        key: 'getCSVAgecomAppli',
	        value: function getCSVAgecomAppli() {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/appli').get();
	        }
	    }, {
	        key: 'getCSVAgecomSynchro',
	        value: function getCSVAgecomSynchro(dtStart, dtEnd) {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/logs').get({ 'dtStart': dtStart, 'dtEnd': dtEnd });
	        }
	    }, {
	        key: 'getCSVCustomerPortal',
	        value: function getCSVCustomerPortal() {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/customers-details').get();
	        }
	    }, {
	        key: 'getCSVCustomerPortalV2',
	        value: function getCSVCustomerPortalV2() {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/customers-details-V2').get();
	        }
	    }, {
	        key: 'getCSVCQRelevance',
	        value: function getCSVCQRelevance() {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/control-relevance-details').get();
	        }
	    }, {
	        key: 'getCSVCQInfra',
	        value: function getCSVCQInfra() {
	            this.restangular.setBaseUrl(this.appConfig.apiBaseUrl);
	            return this.restangular.one('sync/cockpits/control-infra-details').get();
	        }
	    }]);

	    return CockpitService;
	})();

	exports.CockpitService = CockpitService;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CreateFileService = (function () {
	    function CreateFileService() {
	        'ngInject';

	        _classCallCheck(this, CreateFileService);
	    }

	    _createClass(CreateFileService, [{
	        key: 'createFile',
	        value: function createFile(content, type) {
	            var blob = new Blob(['﻿', content], { type: type });
	            return (window.URL || window.webkitURL).createObjectURL(blob);
	        }
	    }, {
	        key: 'downloadFile',
	        value: function downloadFile(url, filename) {
	            var link = document.createElement('a');
	            link.setAttribute('href', url);
	            link.setAttribute('download', filename);
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	        }
	    }, {
	        key: 'createAndDownloadFile',
	        value: function createAndDownloadFile(content, type, filename) {
	            var url = this.createFile(content, type);
	            this.downloadFile(url, filename);
	        }
	    }]);

	    return CreateFileService;
	})();

	exports.CreateFileService = CreateFileService;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var MainController = (function () {
	  function MainController() {
	    'ngInject';

	    _classCallCheck(this, MainController);

	    this.activate();
	  }

	  _createClass(MainController, [{
	    key: 'activate',
	    value: function activate() {}
	  }]);

	  return MainController;
	})();

	exports.MainController = MainController;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var LoginController = function LoginController($state, $log, $scope, $auth, toastr, UserService) {
	    'ngInject';

	    _classCallCheck(this, LoginController);

	    $scope.authenticate = function (provider) {
	        $auth.authenticate(provider).then(function () {
	            UserService.getRoles().then(function () {
	                $state.go('root.view.dashboard');
	            });
	        }, function (error) {
	            toastr.error("Vous n'êtes pas autorisé à accéder à l'application", "Contacter l'administrateur de l'application");
	            $log.debug(error);
	        });
	    };
	};
	LoginController.$inject = ["$state", "$log", "$scope", "$auth", "toastr", "UserService"];

	exports.LoginController = LoginController;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SidebarController = (function () {
	    SidebarController.$inject = ["$state", "LocalStorage"];
	    function SidebarController($state, LocalStorage) {
	        'ngInject';

	        _classCallCheck(this, SidebarController);

	        this.$state = $state;
	        this.LocalStorage = LocalStorage;

	        this.activate();
	    }

	    _createClass(SidebarController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'logout',
	        value: function logout() {
	            localStorage.removeItem('agenor_token');
	            this.LocalStorage.clearLocalStorage();
	            this.$state.go('login');
	        }
	    }]);

	    return SidebarController;
	})();

	exports.SidebarController = SidebarController;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var DashboardController = (function () {
	    DashboardController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$log", "$timeout", "toastr"];
	    function DashboardController($rootScope, $scope, $state, $stateParams, $log, $timeout, toastr) {
	        'ngInject';

	        _classCallCheck(this, DashboardController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.toastr = toastr;
	        this.currentTab = 1;

	        this.activate();
	    }

	    _createClass(DashboardController, [{
	        key: 'activate',
	        value: function activate() {
	            var _this = this;

	            this.currentTab = this.$stateParams.currentTab;
	            switch (this.$stateParams.currentTab) {
	                case null:
	                case 0:
	                    break;

	                case 1:
	                    this.$timeout(function () {
	                        _this.loadSiteTypes();
	                    }, 500);
	                    break;

	                case 2:
	                    this.$timeout(function () {
	                        _this.loadGenericGrids();
	                    }, 500);
	                    break;

	                case 3:
	                    this.$timeout(function () {
	                        _this.loadSharedGrids();
	                    }, 500);
	                    break;

	                case 4:
	                    this.$timeout(function () {
	                        _this.loadCustomGrids();
	                    }, 500);
	                    break;

	                case 5:
	                    this.$timeout(function () {
	                        _this.loadDraftGrids();
	                    }, 500);
	                    break;

	                case 6:
	                    this.$timeout(function () {
	                        _this.loadSuppliers();
	                    }, 500);
	                    break;
	            }
	        }
	    }, {
	        key: 'loadSiteTypes',
	        value: function loadSiteTypes() {
	            this.$scope.$broadcast('loadSiteTypes');
	        }
	    }, {
	        key: 'loadGenericGrids',
	        value: function loadGenericGrids() {
	            this.$scope.$broadcast('loadGenericGrids');
	        }
	    }, {
	        key: 'loadSharedGrids',
	        value: function loadSharedGrids() {
	            this.$scope.$broadcast('loadSharedGrids');
	        }
	    }, {
	        key: 'loadCustomGrids',
	        value: function loadCustomGrids() {
	            this.$scope.$broadcast('loadCustomGrids');
	        }
	    }, {
	        key: 'loadDraftGrids',
	        value: function loadDraftGrids() {
	            this.$scope.$broadcast('loadDraftGrids');
	        }
	    }, {
	        key: 'loadSuppliers',
	        value: function loadSuppliers() {
	            this.$scope.$broadcast('loadSuppliers');
	        }
	    }]);

	    return DashboardController;
	})();

	exports.DashboardController = DashboardController;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SitesController = (function () {
	    SitesController.$inject = ["$scope", "$state", "$log", "toastr", "SiteService"];
	    function SitesController($scope, $state, $log, toastr, SiteService) {
	        'ngInject';

	        _classCallCheck(this, SitesController);

	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.toastr = toastr;
	        this.SiteService = SiteService;
	        this.tableOptions = { order: 'name', limit: 10, page: 1 };
	        this.sites = {};
	        this.selected = [];
	        this.showSearch = false;
	        this.query = '';

	        this.activate();
	    }

	    _createClass(SitesController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getSites();
	        }
	    }, {
	        key: 'getSites',
	        value: function getSites() {
	            var _this = this;

	            this.SiteService.getSites().then(function (success) {
	                _this.sites.data = success;
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des sites');
	                _this.$log.debug(error);
	            });
	        }

	        /* Actions */
	    }, {
	        key: 'toggleSearch',
	        value: function toggleSearch() {
	            if (this.query != '') {
	                this.query = '';
	            }
	            this.showSearch = !this.showSearch;
	            this.tableOptions.page = 1;
	        }
	    }, {
	        key: 'resetPagination',
	        value: function resetPagination() {
	            this.tableOptions.page = 1;
	        }
	    }]);

	    return SitesController;
	})();

	exports.SitesController = SitesController;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditSiteController = (function () {
	    EditSiteController.$inject = ["$state", "$log", "$q", "$stateParams", "$mdDialog", "moment", "toastr", "SiteService", "AgencyService", "SupplierService", "GridService"];
	    function EditSiteController($state, $log, $q, $stateParams, $mdDialog, moment, toastr, SiteService, AgencyService, SupplierService, GridService) {
	        'ngInject';

	        _classCallCheck(this, EditSiteController);

	        this.$state = $state;
	        this.$log = $log;
	        this.$q = $q;
	        this.$stateParams = $stateParams;
	        this.dialog = $mdDialog;
	        this.moment = moment;
	        this.toastr = toastr;
	        this.SiteService = SiteService;
	        this.AgencyService = AgencyService;
	        this.SupplierService = SupplierService;
	        this.GridService = GridService;

	        this.disableButton = false;
	        this.civilities = [{ id: 1, label: 'Mr' }, { id: 2, label: 'Mme' }];

	        this.activate();
	    }

	    _createClass(EditSiteController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getSite();
	            this.getSiteTypes();
	            this.getAgencies();
	        }
	    }, {
	        key: 'getSite',
	        value: function getSite() {
	            var _this = this;

	            this.SiteService.getSite(this.$stateParams.id).then(function (success) {
	                _this.site = success;

	                _this.getSiteArea(_this.$stateParams.id);
	                _this.getSuppliers();
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer les informations du site');
	                _this.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'updateSite',
	        value: function updateSite() {
	            var _this2 = this;

	            var type = angular.copy(this.site.type);

	            if (this.site.site_suppliers) {
	                delete this.site.site_suppliers;
	            }
	            if (this.site.customer) {
	                delete this.site.customer;
	            }
	            if (this.site.manager) {
	                delete this.site.manager;
	            }
	            if (this.site.contact) {
	                delete this.site.contact.id;
	            }
	            if (this.site.salesman) {
	                delete this.site.salesman;
	            }
	            if (angular.isUndefined(this.site.type.hasSites)) {
	                delete this.site.type.hasSites;
	            }
	            delete this.site.address.id;
	            delete this.site.quadra_id;

	            delete this.site.id;
	            this.site.type = type.id;

	            this.site.areaTemplates = [];

	            if (!this.validPostalCode(this.site.address.postal_code)) {
	                this.toastr.success('Le code postal n\'est pas valide');
	                return false;
	            }

	            if (this.site.contact && this.site.contact.gender === 0 || this.site.contact && angular.isUndefined(this.site.contact.gender)) {
	                delete this.site.contact.gender;
	            }

	            /*if(angular.isUndefined(this.site.contact)){
	                this.toastr.error('le champ Civilité et Nom du contact est obligatoire');
	                return false;
	            }
	             if(this.site.contact.last_name === '' || angular.isUndefined(this.site.contact.last_name)){
	                this.toastr.error('le champ Nom de l\'interlocuteur est obligatoire');
	                return false;
	            }*/

	            _.forEach(this.siteArea, function (site) {
	                var elem = {};
	                elem.id = site.id;
	                elem.coefficient = site.coefficient;
	                elem.threshold = site.threshold;
	                _this2.site.areaTemplates.push(elem);
	                //site.idAreaTemplate = site.id;
	                //delete site.id;
	            });

	            var siteSuppliers = [];
	            _.forEach(this.site.suppliers, function (supplier) {
	                siteSuppliers.push(supplier.id);
	            });
	            this.site.suppliers = siteSuppliers;

	            var CurrentDate = this.moment().valueOf();
	            CurrentDate = this.moment(CurrentDate).format('YYYY-MM-DD h:mm:ss');
	            this.site.validated_at = CurrentDate;

	            /*let promises = {
	                udSite : this.SiteService.updateSite(this.$stateParams.id, this.site),
	                udSiteArea : this.SiteService.updateCustomArea(this.$stateParams.id, this.siteArea)
	            };*/

	            this.SiteService.updateSite(this.$stateParams.id, this.site).then(function (values) {
	                _this2.toastr.success('Le site "' + _this2.site.name + '" a bien été mis à jour');
	                _this2.$state.go('root.view.dashboard', { currentTab: 0 });
	                _this2.$log.debug(values);
	            }, function (error) {
	                _this2.toastr.error('Impossible de mettre à jour ce site');
	                _this2.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'getSiteTypes',
	        value: function getSiteTypes() {
	            var _this3 = this;

	            this.SiteService.getSiteTypes().then(function (success) {
	                _this3.types = success;
	            }, function (error) {
	                _this3.toastr.error('Impossible de récupérer les types de site');
	                _this3.$log.error(error);
	            });
	        }
	    }, {
	        key: 'getAgencies',
	        value: function getAgencies() {
	            var _this4 = this;

	            this.AgencyService.getAgencies().then(function (success) {
	                _this4.agencies = success;
	            }, function (error) {
	                _this4.toastr.error('Impossible de récupérer les agences');
	                _this4.$log.error(error);
	            });
	        }

	        // Building management
	    }, {
	        key: 'dropDown',
	        value: function dropDown(bat) {
	            var current = bat.index;
	            var next = current + 1;
	            var itemDown = _.find(this.site.buildings, { 'index': bat.index });
	            var itemUp = _.find(this.site.buildings, { 'index': next });

	            itemDown.index = next;
	            itemUp.index = current;
	        }
	    }, {
	        key: 'dropUp',
	        value: function dropUp(bat) {
	            var current = bat.index;
	            var prev = current - 1;
	            var itemDown = _.find(this.site.buildings, { 'index': prev });
	            var itemUp = _.find(this.site.buildings, { 'index': current });
	            itemDown.index = current;
	            itemUp.index = prev;
	        }
	    }, {
	        key: 'deleteBat',
	        value: function deleteBat(item) {
	            var _this5 = this;

	            this.site.buildings = _.filter(this.site.buildings, function (bat) {
	                if (bat.index !== item.index) {
	                    if (bat.index > item.index) bat.index = bat.index - 1;
	                    return bat;
	                }
	                _this5.disableButton = false;
	            });
	        }
	    }, {
	        key: 'addBat',
	        value: function addBat() {
	            var num = this.site.buildings.length;
	            var newBat = {
	                'name': '',
	                'index': num
	            };
	            this.site.buildings.push(newBat);
	            this.disableButton = true;
	        }

	        // Area Management
	    }, {
	        key: 'getSiteArea',
	        value: function getSiteArea(id) {
	            var _this6 = this;

	            this.SiteService.getSiteArea(id).then(function (success) {
	                _this6.siteArea = success;
	            }, function (error) {
	                _this6.toastr.error('Impossible de récupérer les zones liées à un site');
	                _this6.$log.error(error);
	            });
	        }
	    }, {
	        key: 'addArea',
	        value: function addArea() {
	            var _this7 = this;

	            var addAreaTemplate = this.dialog.confirm({
	                template: '<md-dialog aria-label="Ajout d\'une zone personnalisée" class="areaDialog" ng-cloak>' + '   <form name="form">' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Ajout d\'une zone personnalisée</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="customArea.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <div class="md-block radio-block">' + '                   <label>Cette zone hérite-t-elle d\'une zone générique ?</label>' + '                   <md-radio-group ng-model="customArea.inherit" ng-change="customArea.getGenericAreas()">' + '                       <md-radio-button value="true" class="md-primary">Oui</md-radio-button>' + '                       <md-radio-button value="false">Non</md-radio-button>' + '                   </md-radio-group>' + '               </div>' + '               <md-input-container class="md-block generic-area" ng-if="customArea.inherit === \'true\'">' + '                   <label>Sélectionner le zone générique</label>' + '                   <md-select ng-model="customArea.genericArea" ng-change="customArea.getArea()">' + '                       <md-option ng-repeat="area in customArea.genericAreas" ng-value="area">{{area.name}}</md-option>' + '                   </md-select>' + '               </md-input-container>' + '               <md-input-container class="md-block">' + '                   <label>Nom de la zone personnalisée</label>' + '                   <input type="text" ng-model="customArea.newCustomArea.name" required>' + '                   <span class="error-message" ng-show="customArea.disabled">Ce champ est obligatoire</span>' + '               </md-input-container>' + '               <md-content>' + '                   <h3>Eléments de contrôle</h3>' + '                   <div layout-gt-sm="row">' + '                       <md-input-container class="md-block flex-20" flex-gt-sm>' + '                           <label>Nom</label>' + '                           <input type="text" ng-model="customArea.element_templates.name">' + '                       </md-input-container>' + '                       <md-input-container class="md-block flex-65" flex-gt-sm>' + '                           <label>Critères</label>' + '                           <textarea ng-model="customArea.element_templates.criteria" md-maxlength="150" md-select-on-focus></textarea>' + '                       </md-input-container>' + '                       <md-input-container class="md-block flex-10" flex-gt-sm>' + '                           <label>Coef.</label>' + '                           <input type="number" ng-model="customArea.element_templates.coefficient">' + '                       </md-input-container>' + '                       <md-button class="md-icon-button flex-5" ng-click="customArea.addControlPoint()"><md-icon>add</md-icon></md-button>' + '                   </div>' + '               </md-content>' + '               <md-content>' + '                   <md-table-container>' + '                       <table md-table>' + '                           <thead md-head>' + '                               <tr md-row>' + '                                   <th md-column><span>Elément de contrôle</span></th>' + '                                   <th md-column><span>Critères</span></th>' + '                                   <th md-column><span>Coéf.</span></th>' + '                                   <th md-column>Actions</th>' + '                               </tr>' + '                           </thead>' + '                           <tbody md-body>' + '                               <tr md-row ng-repeat="point in customArea.newCustomArea.element_templates">' + '                                   <td md-cell ng-if="customArea.editItemId !== $index">{{point.name}}</td>' + '                                   <td md-cell ng-if="customArea.editItemId !== $index">{{point.criteria}}</td>' + '                                   <td md-cell ng-if="customArea.editItemId !== $index">{{point.coefficient}}</td>' + '                                   <td md-cell ng-if="customArea.editItemId === $index">' + '                                       <input class="edit" type="text" ng-model="point.name" />' + '                                   </td>' + '                                   <td md-cell ng-if="customArea.editItemId === $index">' + '                                       <textarea class="edit" type="text" ng-model="point.criteria"></textarea>' + '                                   </td>' + '                                   <td md-cell ng-if="customArea.editItemId === $index">' + '                                       <input class="edit" type="number" ng-model="point.coefficient" />' + '                                   </td>' + '                                   <td md-cell class="text-center">' + '                                       <md-button class="md-icon-button " aria-label="Supprimer" ng-click="customArea.removeControlPoint(point)" ng-hide="customArea.editItemId === $index "><md-icon class="material-icons">delete</md-icon></md-button>' + '                                       <md-button class="md-icon-button " aria-label="Editer" ng-click="customArea.editControlPoint($index)" ng-hide="customArea.editItemId === $index "><md-icon class="material-icons">edit</md-icon></md-button>' + '                                       <md-button class="md-icon-button " aria-label="Editer" ng-click="customArea.validEditControlPoint()" ng-if="customArea.editItemId === $index"><md-icon class="material-icons">check</md-icon></md-button>' + '                                   </td>' + '                               </tr>' + '                           </tbody>' + '                       </table>' + '                   </md-table-container>' + '               </md-content>' + '               <md-content>' + '                   <h3>Eléments potentiellements défaillants</h3>' + '                   <div layout-gt-sm="row">' + '                       <md-input-container class="md-block flex-95" flex-gt-sm>' + '                           <label>Nom</label>' + '                           <input type="text" ng-model="customArea.newDeficientElem.name">' + '                       </md-input-container>' + '                       <md-button class="md-icon-button flex-5" ng-click="customArea.addDeficientElem()"><md-icon>add</md-icon></md-button>' + '                   </div>' + '               </md-content>' + '               <md-content>' + '                   <md-table-container>' + '                       <table md-table>' + '                           <thead md-head>' + '                               <tr md-row>' + '                                   <th md-column><span>Eléments potentiellements defaillants</span></th>' + '                                   <th md-column>Actions</th>' + '                               </tr>' + '                           </thead>' + '                           <tbody md-body>' + '                               <tr md-row ng-repeat="elem in customArea.newCustomArea.failing_element_templates">' + '                                   <td md-cell>{{elem.name}}</td>' + '                                   <td md-cell class="text-center">' + '                                       <md-button class="md-icon-button " aria-label="Supprimer" ng-click="customArea.removeDeficientElem(elem)"><md-icon class="material-icons">delete</md-icon></md-button>' + '                                       <div class="tooltip" ng-show="type.hasSites">Impossible, le type est affecté.</div>' + '                                   </td>' + '                               </tr>' + '                           </tbody>' + '                       </table>' + '                   </md-table-container>' + '               </md-content>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="customArea.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="customArea.validDialog()" style="margin-right:20px;" ng-disabled="editDialog.disabled">Enregistrer</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'CustomAreaController',
	                controllerAs: 'customArea',
	                fullscreen: true,
	                locals: {
	                    threshold: this.site.threshold
	                }
	            });

	            this.dialog.show(addAreaTemplate).then(function (data) {
	                var newArea = angular.copy(data);
	                delete newArea.type;
	                delete newArea.coefficient;
	                delete newArea.threshold;
	                _this7.$log.debug(data);
	                _this7.SiteService.updateSiteArea(_this7.$stateParams.id, newArea).then(function (success) {
	                    data.id = success.id;
	                    _this7.$log.debug(success);
	                }, function () {
	                    _this7.toastr.error('Impossible d\'ajouter la zone');
	                });
	                _this7.siteArea.push(data);
	            });
	        }
	    }, {
	        key: 'confirmRemoveArea',
	        value: function confirmRemoveArea(area) {
	            var _this8 = this;

	            var confirm = this.dialog.confirm().title('Suppression').textContent('Confirmer la suppression de la zone : ' + area.name).clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');

	            this.dialog.show(confirm).then(function () {
	                _this8.removeArea(area);
	            });
	        }
	    }, {
	        key: 'removeArea',
	        value: function removeArea(data) {
	            var _this9 = this;

	            this.GridService.removeAreaTemplate(data.id).then(function () {
	                _this9.siteArea = _.filter(_this9.siteArea, function (area) {
	                    if (area.id !== data.id) {
	                        return area;
	                    }
	                });
	            }, function (error) {
	                _this9.toastr.error('Impossible de supprimer la zone');
	                _this9.$log.error(error);
	            });
	        }

	        //Suppliers management
	    }, {
	        key: 'getSuppliers',
	        value: function getSuppliers() {
	            var _this10 = this;

	            this.SupplierService.getSuppliers().then(function (success) {
	                _this10.suppliers = success;
	                _.forEach(_this10.suppliers, function (supplier) {
	                    _.forEach(_this10.site.suppliers, function (siteSupplier) {
	                        if (siteSupplier.id === supplier.id) {
	                            supplier.selected = true;
	                        }
	                    });
	                });
	            }, function () {
	                _this10.toastr.error('Impossible de récupérer la liste des fournisseurs');
	            });
	        }
	    }, {
	        key: 'selectSupplier',
	        value: function selectSupplier(supplier) {
	            if (_.find(this.site.suppliers, { 'id': supplier.id })) {
	                this.site.suppliers = _.remove(this.site.suppliers, function (item) {
	                    if (item.id !== supplier.id) {
	                        return item;
	                    }
	                });
	                supplier.selected = false;
	            } else {
	                this.site.suppliers.push(supplier);
	                supplier.selected = true;
	            }
	        }

	        // Check Empty Field
	    }, {
	        key: 'nameIsNotEmpty',
	        value: function nameIsNotEmpty() {
	            if (this.site.name != undefined) {
	                this.disableButton = false;
	            } else {
	                this.disableButton = true;
	            }
	        }
	    }, {
	        key: 'batNameNotEmpty',
	        value: function batNameNotEmpty(building) {
	            if (building.name != undefined) {
	                this.disableButton = false;
	            } else {
	                this.disableButton = true;
	            }
	        }

	        // Match PostalCode
	    }, {
	        key: 'validPostalCode',
	        value: function validPostalCode(postalCode) {
	            var pattern = '[0-9]{5}';
	            var regex = new RegExp(pattern);
	            return regex.test(postalCode);
	        }
	    }]);

	    return EditSiteController;
	})();

	exports.EditSiteController = EditSiteController;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomAreaController = (function () {
	    CustomAreaController.$inject = ["$state", "$scope", "$log", "toastr", "$mdDialog", "threshold", "GridService"];
	    function CustomAreaController($state, $scope, $log, toastr, $mdDialog, threshold, GridService) {
	        'ngInject';

	        _classCallCheck(this, CustomAreaController);

	        this.$sate = $state;
	        this.$scope = $scope;
	        this.$log = $log;
	        this.toastr = toastr;
	        this.dialog = $mdDialog;
	        this.threshold = threshold;
	        this.newCustomArea = {
	            'name': '',
	            'element_templates': [],
	            'failing_element_templates': [],
	            'type': 2,
	            'threshold': this.threshold,
	            'coefficient': 1
	        };
	        this.element_templates = {
	            'coefficient': 1
	        };
	        this.newDeficientElem = {};
	        this.editItemId = null;
	        this.inherit = false;
	        this.GridService = GridService;

	        this.activate();
	    }

	    _createClass(CustomAreaController, [{
	        key: 'activate',
	        value: function activate() {}

	        // Dialog actions
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            if (angular.isUndefined(this.newCustomArea.name) || this.newCustomArea.name === '') {
	                this.toastr.warning('Le nom de la zone est obligatoire');
	                return false;
	            } else if (this.newCustomArea.element_templates.length === 0) {
	                this.toastr.warning('Au moins un élément de contrôle est obligatoire');
	                return false;
	            } else {
	                this.dialog.hide(this.newCustomArea);
	            }
	        }

	        //Control Point
	    }, {
	        key: 'addControlPoint',
	        value: function addControlPoint() {
	            if (angular.isUndefined(this.element_templates.name) || angular.isUndefined(this.element_templates.criteria) || angular.isUndefined(this.element_templates.coefficient)) {
	                this.toastr.warning('Tous les champs sont obligatoires', 'Ajout d\'un Point de contrôle');
	            } else {
	                this.newCustomArea.element_templates.push(this.element_templates);
	                this.element_templates = {
	                    'coefficient': 1
	                };
	            }
	        }
	    }, {
	        key: 'editControlPoint',
	        value: function editControlPoint(index) {
	            this.editItemId = index;
	        }
	    }, {
	        key: 'validEditControlPoint',
	        value: function validEditControlPoint() {
	            this.editItemId = null;
	        }
	    }, {
	        key: 'removeControlPoint',
	        value: function removeControlPoint(point) {
	            this.newCustomArea.element_templates = _.filter(this.newCustomArea.element_templates, function (e) {
	                if (e.name !== point.name) {
	                    return e;
	                }
	            });
	        }

	        //Deficient elements
	    }, {
	        key: 'addDeficientElem',
	        value: function addDeficientElem() {
	            if (angular.isUndefined(this.newDeficientElem.name) || this.newDeficientElem.name === '') {
	                this.toastr.warning('Tous les champs sont obligatoires', 'Ajout d\'un Nom d\'élément potentiellement defaillant');
	            } else {
	                this.newCustomArea.failing_element_templates.push(this.newDeficientElem);
	                this.newDeficientElem = {};
	            }
	        }
	    }, {
	        key: 'removeDeficientElem',
	        value: function removeDeficientElem(elem) {
	            this.newCustomArea.failing_element_templates = _.filter(this.newCustomArea.failing_element_templates, function (e) {
	                if (e.name !== elem.name) {
	                    return e;
	                }
	            });
	        }

	        //select from generic Area
	    }, {
	        key: 'getGenericAreas',
	        value: function getGenericAreas() {
	            var _this = this;

	            var type = 0;
	            if (this.inherit === 'true' && angular.isUndefined(this.genericAreas)) {
	                this.GridService.getGrids(type).then(function (success) {
	                    _this.genericAreas = success;
	                }, function (error) {
	                    _this.toastr.error('Impossible de récupérer les grilles génériques');
	                    _this.$log.debug(error);
	                });
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'getArea',
	        value: function getArea() {
	            var _this2 = this;

	            this.GridService.getAreaTemplate(this.genericArea.id).then(function (data) {
	                _this2.newCustomArea.element_templates = data.element_templates;
	                _this2.newCustomArea.failing_element_templates = data.failing_element_templates;
	            }, function () {
	                _this2.toastr.error('Impossible de récupérer la grille');
	            });
	        }
	    }]);

	    return CustomAreaController;
	})();

	exports.CustomAreaController = CustomAreaController;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SitesTypeController = (function () {
	    SitesTypeController.$inject = ["$scope", "$state", "$log", "$mdDialog", "toastr", "SiteService"];
	    function SitesTypeController($scope, $state, $log, $mdDialog, toastr, SiteService) {
	        'ngInject';

	        _classCallCheck(this, SitesTypeController);

	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.dialog = $mdDialog;
	        this.toastr = toastr;
	        this.SiteService = SiteService;

	        this.disableButton = false;
	        this.tableOptions = { order: 'name', limit: 10, page: 1 };
	        this.siteTypes = {};
	        this.showSearch = false;
	        this.newType = null;

	        this.activate();
	    }

	    _createClass(SitesTypeController, [{
	        key: 'activate',
	        value: function activate() {
	            var _this = this;

	            this.$scope.$on('loadSiteTypes', function () {
	                if (_this.siteTypes.count) {
	                    return false;
	                } else {
	                    _this.getSiteTypes();
	                }
	            });
	        }
	    }, {
	        key: 'getSiteTypes',
	        value: function getSiteTypes() {
	            var _this2 = this;

	            this.SiteService.getSiteTypes().then(function (success) {
	                _this2.siteTypes.count = success.length;
	                _this2.siteTypes.data = success;
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer les types de chantiers');
	                _this2.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'addSiteType',
	        value: function addSiteType() {
	            var _this3 = this;

	            var addType = {};
	            addType.name = this.newType;
	            this.disableButton = true;
	            this.SiteService.addSiteType(addType).then(function () {
	                _this3.toastr.success('Le type de chantier "' + _this3.newType + '" a bien été ajouté');
	                _this3.newType = null;
	                _this3.disableButton = false;
	                _this3.getSiteTypes();
	            }, function (error) {
	                _this3.toastr.error('Impossible d\'ajouter le type de chantier');
	                _this3.disableButton = false;
	                _this3.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'editSiteType',
	        value: function editSiteType(id, data) {
	            var _this4 = this;

	            this.SiteService.editSiteType(id, data).then(function () {
	                _this4.toastr.success('Le type de chantier a bien été modifié');
	                _this4.getSiteTypes();
	            }, function (error) {
	                _this4.toastr.error('Impossible de mettre à jour le type de chantier');
	                _this4.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'deleteSiteType',
	        value: function deleteSiteType(id) {
	            var _this5 = this;

	            this.SiteService.deleteSiteType(id).then(function () {
	                _this5.toastr.success('Le type de chantier a bien été supprimé');
	                _this5.getSiteTypes();
	            }, function (error) {
	                _this5.toastr.error('Impossible de supprimer le type de chantier');
	                _this5.$log.debug(error);
	            });
	        }

	        /* Modal */
	    }, {
	        key: 'showDeleteModal',
	        value: function showDeleteModal(type) {
	            var _this6 = this;

	            var confirm = this.dialog.confirm().title('Suppression').textContent('Confirmer la suppression du type de chantier : ' + type.name).clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');

	            this.dialog.show(confirm).then(function () {
	                _this6.deleteSiteType(type.id);
	            });
	        }
	    }, {
	        key: 'showEditModal',
	        value: function showEditModal(type) {
	            var _this7 = this;

	            var modifiedType = angular.copy(type);
	            var edit = this.dialog.confirm({
	                //templateUrl:'/app/views/content/dashboard/sitesType/editDialog/editDialog.html',
	                template: '<md-dialog aria-label="Edition du type de chantier"  ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Edition du type de chantier</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="editDialog.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <input type="text" ng-model="editDialog.type.name" required ng-change="editDialog.isNotEmpty()">' + '                   <span class="error-message" ng-show="editDialog.disabled">Ce champ est obligatoire</span>' + '               </md-input-container>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="editDialog.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="editDialog.validDialog()" style="margin-right:20px;" ng-disabled="editDialog.disabled">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'EditDialogController',
	                controllerAs: 'editDialog',
	                locals: {
	                    type: modifiedType
	                }
	            });

	            this.dialog.show(edit).then(function (data) {
	                var type = {};
	                type.name = data.name;
	                _this7.editSiteType(data.id, type);
	            }, function () {});
	        }

	        /* Actions */
	    }, {
	        key: 'toggleSearch',
	        value: function toggleSearch() {
	            if (this.search !== '') {
	                this.search = '';
	            }
	            this.showSearch = !this.showSearch;
	            this.tableOptions.page = 1;
	        }
	    }, {
	        key: 'resetPagination',
	        value: function resetPagination() {
	            this.tableOptions.page = 1;
	        }
	    }]);

	    return SitesTypeController;
	})();

	exports.SitesTypeController = SitesTypeController;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditDialogController = (function () {
	    EditDialogController.$inject = ["$state", "$scope", "type", "$mdDialog"];
	    function EditDialogController($state, $scope, type, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, EditDialogController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.type = type;
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.activate();
	    }

	    _createClass(EditDialogController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'isNotEmpty',
	        value: function isNotEmpty() {
	            if (this.type.name != undefined) {
	                this.disabled = false;
	            } else {
	                this.disabled = true;
	            }
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.type);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditDialogController;
	})();

	exports.EditDialogController = EditDialogController;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var ActionCorrectiveFormController = (function () {
	    ActionCorrectiveFormController.$inject = ["$mdDialog", "point"];
	    function ActionCorrectiveFormController($mdDialog, point) {
	        'ngInject';

	        _classCallCheck(this, ActionCorrectiveFormController);

	        this.dialog = $mdDialog;
	        this.point = point;
	        this.activate();
	    }

	    _createClass(ActionCorrectiveFormController, [{
	        key: 'activate',
	        value: function activate() {
	            this.checkEditOrNew();
	        }
	    }, {
	        key: 'checkEditOrNew',
	        value: function checkEditOrNew() {
	            if (angular.isUndefined(this.point.fix_element_templates)) {
	                this.type = 'add';
	                this.point = {
	                    'fix_element_templates': []
	                };
	            } else {
	                this.type = 'edit';
	            }
	        }
	    }, {
	        key: 'addAction',
	        value: function addAction() {
	            var action = {};
	            action.content = this.correctiveActionName;
	            this.point.fix_element_templates.push(action);
	            this.correctiveActionName = null;
	        }
	    }, {
	        key: 'removeAction',
	        value: function removeAction(action) {
	            this.point.fix_element_templates = _.filter(this.point.fix_element_templates, function (elem) {
	                if (action.content != elem.content) {
	                    return elem;
	                }
	            });
	        }

	        // Dialog actions
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide({ type: this.type, data: this.point });
	        }
	    }]);

	    return ActionCorrectiveFormController;
	})();

	exports.ActionCorrectiveFormController = ActionCorrectiveFormController;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';

	GenericGridListController.$inject = ["$state", "GridService", "orderByFilter"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GenericGridListController = GenericGridListController;

	function GenericGridListController($state, GridService, orderByFilter) {
	    'ngInject';

	    this.gridType = 0;
	    this.eventName = 'loadGenericGrids';
	    this.columns = ['name', 'types'];
	    this.actions = ['edit', 'delete'];

	    this.transformGrid = function (grid) {
	        return {
	            id: grid.id,
	            name: grid.name,
	            types: orderByFilter(grid['site_type_area_templates'].map(function (obj) {
	                return obj['site_type'].name;
	            })).join(', '),
	            counts: {
	                types: grid['site_type_area_templates'].length,
	                sites: grid['site_area_templates_count']
	            },
	            editable: true
	        };
	    };

	    this.deleteGridPromise = function (grid) {
	        return GridService.removeAreaTemplate(grid.id);
	    };

	    this.getEditionLink = function (grid) {
	        return $state.href('root.view.editGenericGrid', { id: grid.id });
	    };

	    this.getDeleteConfirmationText = function (grid) {
	        return 'Confirmer la suppression de la grille "' + grid.name + '" (associée à ' + grid.counts.types + ' types de chantiers et ' + grid.counts.sites + ' chantiers) ?';
	    };
	}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var GenericGridFormController = function GenericGridFormController() {
	    'ngInject';

	    _classCallCheck(this, GenericGridFormController);

	    this.gridType = 'générique';
	    this.affectations = ['types'];
	    this.cleanGrid = function (grid) {
	        delete grid.sites;

	        return grid;
	    };
	    this.canAddCorrection = true;
	};

	exports.GenericGridFormController = GenericGridFormController;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';

	SharedGridListController.$inject = ["$state", "GridService"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.SharedGridListController = SharedGridListController;

	function SharedGridListController($state, GridService) {
	    'ngInject';

	    this.gridType = 1;
	    this.eventName = 'loadSharedGrids';
	    this.columns = ['name', 'agency', 'manager', 'site'];
	    this.actions = ['edit', 'delete'];

	    this.transformGrid = function (grid) {
	        return {
	            id: grid['area_template'].id,
	            siteAreaTemplateId: grid.id,
	            name: grid['area_template'].name,
	            site: grid.site.name,
	            agency: grid.site.manager.agency.name,
	            manager: grid.site.manager['first_name'] + ' ' + grid.site.manager['last_name'],
	            editable: parseInt(grid['area_template']['site_area_templates_count']) > 0 && grid['area_template']['site_type_area_templates'].length === 0
	        };
	    };

	    this.deleteGridPromise = function (grid) {
	        return GridService.removeAreaTemplate(grid.id);
	    };

	    this.getEditionLink = function (grid) {
	        return $state.href('root.view.editSharedGrid', { id: grid.id });
	    };

	    this.getDeleteConfirmationText = function (grid) {
	        return 'Confirmer la suppression de la grille : ' + grid.name + ' ?';
	    };
	}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SharedGridFormController = function SharedGridFormController() {
	    'ngInject';

	    _classCallCheck(this, SharedGridFormController);

	    this.gridType = 'partagée';
	    this.affectations = ['sites'];
	    this.cleanGrid = function (grid) {
	        return grid;
	    };
	    this.canAddCorrection = true;
	};

	exports.SharedGridFormController = SharedGridFormController;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';

	CustomGridListController.$inject = ["$state", "GridService"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.CustomGridListController = CustomGridListController;

	function CustomGridListController($state, GridService) {
	    'ngInject';

	    this.gridType = 2;
	    this.eventName = 'loadCustomGrids';
	    this.columns = ['name', 'agency', 'manager', 'site'];
	    this.actions = ['edit', 'delete'];

	    this.transformGrid = function (grid) {
	        return {
	            id: grid['area_template'].id,
	            siteAreaTemplateId: grid.id,
	            name: grid['area_template'].name,
	            site: grid.site.name,
	            agency: grid.site.manager.agency.name,
	            manager: grid.site.manager['first_name'] + ' ' + grid.site.manager['last_name'],
	            editable: parseInt(grid['area_template']['site_area_templates_count']) === 1 && grid['area_template']['site_type_area_templates'].length === 0
	        };
	    };

	    this.deleteGridPromise = function (grid) {
	        return GridService.removeAreaTemplate(grid.id);
	    };

	    this.getEditionLink = function (grid) {
	        return $state.href('root.view.editCustomGrid', { id: grid.id });
	    };

	    this.getDeleteConfirmationText = function (grid) {
	        return 'Confirmer la suppression de la grille : ' + grid.name + ' ?';
	    };
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomGridFormController = function CustomGridFormController() {
	    'ngInject';

	    _classCallCheck(this, CustomGridFormController);

	    this.gridType = 'personnalisée';
	    this.affectations = ['sitesRead', 'typesRead'];
	    this.cleanGrid = function (grid) {
	        return grid;
	    };
	    this.canAddCorrection = false;
	};

	exports.CustomGridFormController = CustomGridFormController;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';

	DraftGridListController.$inject = ["$state", "GridService"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.DraftGridListController = DraftGridListController;

	function DraftGridListController($state, GridService) {
	    'ngInject';

	    this.gridType = 3;
	    this.eventName = 'loadDraftGrids';
	    this.columns = ['name', 'icon'];
	    this.actions = ['edit', 'delete'];

	    this.transformGrid = function (grid) {
	        return Object.assign({ editable: true }, grid);
	    };

	    this.deleteGridPromise = function (grid) {
	        return GridService.removeAreaTemplate(grid.id);
	    };

	    this.getEditionLink = function (grid) {
	        return $state.href('root.view.editDraftGrid', { id: grid.id });
	    };

	    this.getDeleteConfirmationText = function (grid) {
	        return 'Confirmer la suppression de la grille : ' + grid.name + ' ?';
	    };
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var DraftGridFormController = function DraftGridFormController() {
	    'ngInject';

	    _classCallCheck(this, DraftGridFormController);

	    this.gridType = 'brouillon';
	    this.affectations = ['sites', 'types'];
	    this.cleanGrid = function (grid) {
	        return grid;
	    };
	    this.canAddCorrection = true;
	};

	exports.DraftGridFormController = DraftGridFormController;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SupplierController = (function () {
	    SupplierController.$inject = ["$log", "$state", "$scope", "$mdDialog", "toastr", "SupplierService"];
	    function SupplierController($log, $state, $scope, $mdDialog, toastr, SupplierService) {
	        'ngInject';

	        _classCallCheck(this, SupplierController);

	        this.$log = $log;
	        this.$state = $state;
	        this.$scope = $scope;
	        this.dialog = $mdDialog;
	        this.toastr = toastr;
	        this.SupplierService = SupplierService;

	        this.suppliers = {};
	        this.pagination = {
	            perPage: 6,
	            page: 1
	        };

	        this.activate();
	    }

	    _createClass(SupplierController, [{
	        key: 'activate',
	        value: function activate() {
	            var _this = this;

	            this.$scope.$on('loadSuppliers', function () {
	                if (_this.suppliers.count) {
	                    return false;
	                } else {
	                    _this.getSuppliers();
	                }
	            });
	        }
	    }, {
	        key: 'getSuppliers',
	        value: function getSuppliers() {
	            var _this2 = this;

	            this.SupplierService.getSuppliers().then(function (success) {
	                _this2.suppliers.count = success.length;
	                _this2.suppliers.data = success;
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer la liste des fournisseurs');
	                _this2.$log.error(error);
	            });
	        }
	    }, {
	        key: 'deleteSupplier',
	        value: function deleteSupplier(supplier) {
	            var _this3 = this;

	            this.SupplierService.deleteSupplier(supplier.id).then(function (success) {
	                _this3.$log.debug(success);
	                _this3.getSuppliers();
	                _this3.toastr.success('Le matériel "' + supplier.name + '" a bien été supprimé');
	            }, function (error) {
	                _this3.toastr.error('Impossible de supprimer le fournisseur');
	                _this3.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'activeSearch',
	        value: function activeSearch() {
	            this.pagination.page = 1;
	        }

	        /* Modal */
	    }, {
	        key: 'showDeleteModal',
	        value: function showDeleteModal(supplier) {
	            var _this4 = this;

	            var confirm = this.dialog.confirm().title('Suppression').textContent('Confirmer la suppression du matériel : ' + supplier.name).clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');

	            this.dialog.show(confirm).then(function () {
	                _this4.deleteSupplier(supplier);
	            });
	        }
	    }, {
	        key: 'showEditModal',
	        value: function showEditModal(action, sup) {
	            var _this5 = this;

	            var modifiedSupplier = undefined;
	            if (sup) {
	                modifiedSupplier = angular.copy(sup);
	            } else {
	                modifiedSupplier = {
	                    description: ''
	                };
	            }

	            var edit = this.dialog.confirm({
	                //templateUrl:'/app/views/content/dashboard/supplier/editSupplier/editSupplier.html',
	                template: '<md-dialog aria-label="Edition du matériel"  ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Edition du matériel</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="editSupplier.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <label>Nom du fournisseur</label>' + '                   <input type="text" ng-model="editSupplier.supplier.name" required ng-change="editSupplier.isValidName()" aria-label="Nom du matériel">' + '                   <span class="error-message" ng-show="editSupplier.validName">Ce champ est obligatoire</span>' + '                   <span class="error-message" ng-show="editSupplier.existName">Ce nom existe déjà</span>' + '               </md-input-container>' + '               <md-input-container>' + '                   <label>Description</label>' + '                   <textarea  ng-model="editSupplier.supplier.description" aria-label="Description du matériel"></textarea>' + '               </md-input-container>' + '               <md-input-container>' + '                   <label>Lien internet</label>' + '                   <input type="text" ng-model="editSupplier.supplier.link" required ng-change="editSupplier.isValidUrl()" aria-label="Lien vers le fournisseur">' + '                   <span class="error-message" ng-show="editSupplier.requiredUrl">Ce champ est obligatoire</span>' + '                   <span class="error-message" ng-show="editSupplier.invalidUrl">Ce champ n\'est pas une Url valide (exp: http://www.nomdufabricant.fr)</span>' + '               </md-input-container>' + '               <md-input-container>' + '                   <label>Logo</label>' + '                   <input type="file" ngf-select ngf-resize="{width: 80, height: 80, centerCrop: true}" ng-model="picFile" name="file" accept="image/*" aria-label="Image du materiel">' + '               </md-input-container>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="editSupplier.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="editSupplier.saveSupplier(picFile)" style="margin-right:20px;" ng-disabled="editSupplier.disabled">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'EditSupplierController',
	                controllerAs: 'editSupplier',
	                locals: {
	                    supplier: modifiedSupplier,
	                    suppliers: this.suppliers
	                }
	            });

	            this.dialog.show(edit).then(function () {
	                _this5.getSuppliers();
	            }, function (error) {
	                _this5.$log.error(error);
	            });
	        }
	    }]);

	    return SupplierController;
	})();

	exports.SupplierController = SupplierController;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditSupplierController = (function () {
	    EditSupplierController.$inject = ["$state", "$scope", "$log", "supplier", "suppliers", "$mdDialog", "appConfig", "Upload", "SupplierService", "toastr"];
	    function EditSupplierController($state, $scope, $log, supplier, suppliers, $mdDialog, appConfig, Upload, SupplierService, toastr) {
	        'ngInject';

	        _classCallCheck(this, EditSupplierController);

	        this.$sate = $state;
	        this.$scope = $scope;
	        this.$log = $log;
	        this.supplier = supplier;
	        this.suppliers = suppliers;
	        this.dialog = $mdDialog;
	        this.Upload = Upload;
	        this.appConfig = appConfig;
	        this.SupplierService = SupplierService;
	        this.disabled = true;
	        this.validName = true;
	        this.requiredUrl = true;
	        this.invalidUrl = false;
	        this.existName = false;
	        this.toastr = toastr;

	        this.activate();
	    }

	    _createClass(EditSupplierController, [{
	        key: 'activate',
	        value: function activate() {
	            this.isValidName();
	            this.isValidUrl();
	        }
	    }, {
	        key: 'isValidName',
	        value: function isValidName() {
	            if (angular.isDefined(this.supplier.name)) {
	                this.disabled = false;
	                this.validName = false;
	                this.existName = false;
	            } else {
	                this.validName = true;
	                this.disabled = true;
	            }
	        }
	    }, {
	        key: 'isValidUrl',
	        value: function isValidUrl() {
	            if (angular.isUndefined(this.supplier.link)) {
	                this.requiredUrl = true;
	            } else {
	                this.requiredUrl = false;
	                var urlregex = new RegExp("^(http|https|ftp)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$");
	                if (urlregex.test(this.supplier.link)) {
	                    this.invalidUrl = false;
	                } else {
	                    this.invalidUrl = true;
	                }
	            }
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }, {
	        key: 'saveSupplier',
	        value: function saveSupplier(image) {
	            var _this = this;

	            if (this.isDuplicateName()) {
	                this.existName = true;
	                this.disabled = true;
	                return;
	            }

	            var supplierData = angular.toJson({
	                name: this.supplier.name,
	                description: this.supplier.description,
	                link: this.supplier.link
	            });

	            var promise = this.supplier.id ? this.SupplierService.updateSupplier(this.supplier.id, supplierData, image) : this.SupplierService.addSupplier(supplierData, image);

	            promise.then(function (success) {
	                _this.$log.debug(success);
	                _this.dialog.hide('reload');
	            }, function (error) {
	                _this.toastr.error(_this.supplier.id ? 'Impossible de mettre à jour le fournisseur' : 'Impossible d\'ajouter le fournisseur');
	                _this.$log.error(error);
	            });
	        }
	    }, {
	        key: 'isDuplicateName',
	        value: function isDuplicateName() {
	            var existing = _.find(this.suppliers.data, { name: this.supplier.name });
	            return !!existing && existing.id !== this.supplier.id;
	        }
	    }]);

	    return EditSupplierController;
	})();

	exports.EditSupplierController = EditSupplierController;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var RightManagmentController = (function () {
	    RightManagmentController.$inject = ["$rootScope", "$scope", "$state", "$log", "toastr"];
	    function RightManagmentController($rootScope, $scope, $state, $log, toastr) {
	        'ngInject';

	        _classCallCheck(this, RightManagmentController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.toastr = toastr;

	        this.activate();
	    }

	    _createClass(RightManagmentController, [{
	        key: 'activate',
	        value: function activate() {}
	    }]);

	    return RightManagmentController;
	})();

	exports.RightManagmentController = RightManagmentController;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var UsersController = (function () {
	    UsersController.$inject = ["$rootScope", "$scope", "$state", "$log", "$mdDialog", "toastr", "UserService", "AgencyService"];
	    function UsersController($rootScope, $scope, $state, $log, $mdDialog, toastr, UserService, AgencyService) {
	        'ngInject';

	        _classCallCheck(this, UsersController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.dialog = $mdDialog;
	        this.toastr = toastr;

	        this.UserService = UserService;
	        this.AgencyService = AgencyService;

	        this.tableOptions = { order: 'lastname', limit: 10, page: 1 };
	        this.selected = [];
	        this.newUser = {
	            email: null,
	            role: null,
	            quadra_id: null,
	            agency: null,
	            phone: null
	        };
	        this.showSearch = false;

	        this.activate();
	    }

	    _createClass(UsersController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getUsers();
	            this.getRoles();
	            this.getAgencies();
	        }
	    }, {
	        key: 'getUsers',
	        value: function getUsers() {
	            var _this = this;

	            this.UserService.getUsers().then(function (success) {
	                _this.users = success;
	                _this.userCount = success.length;

	                _this.users.forEach(function (user) {
	                    user.active = !user.inactive_date;
	                });
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des utilisateurs');
	                _this.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'addUser',
	        value: function addUser() {
	            var _this2 = this;

	            this.UserService.addUser(this.newUser).then(function () {
	                _this2.toastr.success('L\'utilisateur a été ajouté');
	                _this2.getUsers();
	                _this2.newUser = { email: null, role: null, quadra_id: null, agency: null, phone: null };
	            }, function (error) {
	                var errorData = error.data.children;
	                if (error.status === 400) {
	                    var _error = Object.keys(errorData).find(function (key) {
	                        return errorData[key].errors;
	                    });
	                    _this2.toastr.error('Cet ' + _error + ' est déjà utilisé par un autre utilisateur.');
	                } else {
	                    _this2.toastr.error('Impossible d\'ajouter l\'utilisateur');
	                }
	            });
	        }
	    }, {
	        key: 'editUser',
	        value: function editUser(user) {
	            var _this3 = this;

	            var editedUser = angular.copy(user);
	            this.$log.debug(editedUser);
	            var edit = this.dialog.confirm({
	                template: '<md-dialog aria-label="Édition d\'un utilisateur" ng-cloak>\n                           <form>\n                               <md-toolbar>\n                                   <div class="md-toolbar-tools">\n                                       <h2>Édition de l\'utilisateur {{ editUser.user.first_name }} {{ editUser.user.last_name }}</h2>\n                                       <span flex></span>\n                                       <md-button class="md-icon-button" ng-click="editUser.closeDialog()">\n                                           <md-icon aria-label="Close dialog">close</md-icon>\n                                       </md-button>\n                                   </div>\n                               </md-toolbar>\n                               <md-dialog-content>\n                                   <div class="md-dialog-content">\n                                       <md-input-container class="md-block flex-95">\n                                           <label>Email</label>\n                                           <input type="text" ng-model="editUser.user.email">\n                                       </md-input-container>\n                                       <md-input-container>\n                                           <label>Rôle</label>\n                                           <md-select ng-model="editUser.user.roles[0]">\n                                               <md-option ng-value="role" ng-repeat="role in editUser.roles">{{ role }}</md-option>\n                                           </md-select>\n                                       </md-input-container>\n                                       <md-input-container>\n                                           <label>Agence</label>\n                                           <md-select ng-model="editUser.user.agency" ng-model-options="{trackBy: \'$value.id\'}">\n                                               <md-option ng-value="agency" ng-repeat="agency in editUser.agencies">{{ agency.name }}</md-option>\n                                           </md-select>\n                                       </md-input-container>\n                                       <md-input-container class="md-block flex-95">\n                                           <label>Téléphone</label>\n                                           <input type="text" ng-model="editUser.user.phone">\n                                       </md-input-container>\n                                       <md-input-container class="md-block flex-95">\n                                           <label>ID Quadra</label>\n                                           <input type="text" ng-model="editUser.user.quadra_id">\n                                       </md-input-container>\n                                   </div>\n                               </md-dialog-content>\n                               <md-dialog-actions layout="row">\n                                   <span flex></span>\n                                   <md-button ng-click="editUser.closeDialog()">Annuler</md-button>\n                                   <md-button ng-click="editUser.validDialog()" style="margin-right:20px;" ng-disabled="editUser.disabled">Valider</md-button>\n                               </md-dialog-actions>\n                           </form>\n                        </md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'EditUserRoleController',
	                controllerAs: 'editUser',
	                locals: {
	                    user: editedUser,
	                    roles: this.roles,
	                    agencies: this.agencies
	                }
	            });

	            this.dialog.show(edit).then(function (data) {
	                _this3.updateUser(data);
	            });
	        }
	    }, {
	        key: 'editUserAgencies',
	        value: function editUserAgencies(user) {
	            var _this4 = this;

	            var editedUser = angular.copy(user);
	            this.$log.debug(editedUser);
	            var edit = this.dialog.confirm({
	                template: '<md-dialog aria-label="Édition des agences secondaires d\'un utilisateur" ng-cloak>\n                           <form>\n                               <md-toolbar>\n                                   <div class="md-toolbar-tools">\n                                       <h2>Agences secondaires de {{ editUserAgencies.user.first_name }} {{ editUserAgencies.user.last_name }}</h2>\n                                       <span flex></span>\n                                       <md-button class="md-icon-button" ng-click="editUserAgencies.closeDialog()">\n                                           <md-icon aria-label="Close dialog">close</md-icon>\n                                       </md-button>\n                                       </md-button>\n                                   </div>\n                               </md-toolbar>\n                               <md-dialog-content>\n                                   <div class="md-dialog-content" >\n                                        <div ng-repeat="agency in editUserAgencies.agencies  | orderBy:\'name\'">\n                                            <md-checkbox ng-click="editUserAgencies.toggleAgencyCheckbox(agency)" ng-checked="editUserAgencies.isAgencyCheckboxChecked(agency)" ng-disabled="editUserAgencies.isAgencyCheckboxDisabled(agency)">{{ agency.name }}</md-checkbox>\n                                            <br>\n                                        </div>\n                                   </div>\n                               </md-dialog-content>\n                               <md-dialog-actions layout="row">\n                                   <span flex></span>\n                                   <md-button ng-click="editUserAgencies.closeDialog()">Annuler</md-button>\n                                   <md-button ng-click="editUserAgencies.validDialog()" style="margin-right:20px;" ng-disabled="editUserAgencies.disabled">Valider</md-button>\n                               </md-dialog-actions>\n                           </form>\n                        </md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'EditUserSecondaryAgenciesController',
	                controllerAs: 'editUserAgencies',
	                locals: {
	                    user: editedUser,
	                    roles: this.roles,
	                    agencies: this.agencies,
	                    userAgencies: this.UserService.getUserSecondaryAgencies(editedUser.id)
	                }
	            });

	            this.dialog.show(edit).then(function (data) {
	                _this4.UserService.updateUser(editedUser.id, data);
	            });
	        }
	    }, {
	        key: 'editManagerPlanningsAccess',
	        value: function editManagerPlanningsAccess(user) {
	            var _this5 = this;

	            var editedUser = angular.copy(user);
	            this.$log.debug(editedUser);
	            var edit = this.dialog.confirm({
	                template: '<md-dialog aria-label="Plannings accessibles par l\'utilisateur" ng-cloak>\n                           <form>\n                               <md-toolbar>\n                                   <div class="md-toolbar-tools">\n                                       <h2>Plannings accessibles par l\'utilisateur {{ editManagerPlanningsAccess.user.first_name }} {{ editManagerPlanningsAccess.user.last_name }}</h2>\n                                       <span flex></span>\n                                       <md-button class="md-icon-button" ng-click="editManagerPlanningsAccess.closeDialog()">\n                                           <md-icon aria-label="Close dialog">close</md-icon>\n                                       </md-button>\n                                       </md-button>\n                                   </div>\n                               </md-toolbar>\n                               <md-dialog-content>\n                                   <div class="md-dialog-content" >\n                                        <div ng-repeat="manager in editManagerPlanningsAccess.managers | orderBy:\'first_name\' | filter:editManagerPlanningsAccess.hasLastName">\n                                            <md-checkbox ng-click="editManagerPlanningsAccess.toggleManagerCheckbox(manager)" ng-checked="editManagerPlanningsAccess.isManagerCheckboxChecked(manager)" ng-disabled="editManagerPlanningsAccess.isManagerCheckboxDisabled(manager)">{{ manager.first_name }} {{ manager.last_name }}</md-checkbox>\n                                            <br>\n                                        </div>\n                                   </div>\n                               </md-dialog-content>\n                               <md-dialog-actions layout="row">\n                                   <span flex></span>\n                                   <md-button ng-click="editManagerPlanningsAccess.closeDialog()">Annuler</md-button>\n                                   <md-button ng-click="editManagerPlanningsAccess.validDialog()" style="margin-right:20px;" ng-disabled="editManagerPlanningsAccess.disabled">Valider</md-button>\n                               </md-dialog-actions>\n                           </form>\n                        </md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'EditManagerPlanningsAccessController',
	                controllerAs: 'editManagerPlanningsAccess',
	                locals: {
	                    user: editedUser,
	                    roles: this.roles
	                }
	            });

	            this.dialog.show(edit).then(function (data) {
	                _this5.UserService.updateUser(editedUser.id, data);
	            });
	        }
	    }, {
	        key: 'updateUser',
	        value: function updateUser(user) {
	            var _this6 = this;

	            this.$log.debug(user);
	            var userUpdated = {
	                role: user.roles[0],
	                email: user.email,
	                inactiveDate: user.active ? null : 'inactive_date' in user ? user.inactive_date : new Date(),
	                quadraId: user.quadra_id,
	                agency: user.agency.id,
	                phone: user.phone,
	                firstName: user.first_name,
	                lastName: user.last_name,
	                googleId: user.google_id,
	                googleAccessToken: user.google_access_token
	            };

	            this.UserService.updateUser(user.id, userUpdated).then(function () {
	                _this6.toastr.success('L\'utilisateur ' + user.email + ' a bien été mis à jour');
	                _this6.selected = [];
	                _this6.getUsers();
	            }, function () {
	                _this6.toastr.error('Impossible de mettre à jour l\'utilisateur ' + user.email);
	            });
	        }
	    }, {
	        key: 'deleteUser',
	        value: function deleteUser(user) {
	            var _this7 = this;

	            this.UserService.deleteUser(user.id).then(function () {
	                _this7.toastr.success('L\'utilisateur ' + user.email + ' a bien été supprimé');
	                _this7.selected = [];
	                _this7.getUsers();
	            }, function () {
	                _this7.toastr.error('Impossible de supprimer l\'utilisateur ' + user.email);
	            });
	        }
	    }, {
	        key: 'getRoles',
	        value: function getRoles() {
	            var _this8 = this;

	            this.UserService.getRoles().then(function (success) {
	                _this8.roles = success;
	            }, function (error) {
	                _this8.toastr.error('Impossible de récupérer la liste des rôles');
	                _this8.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'toggleSearch',
	        value: function toggleSearch() {
	            this.showSearch = !this.showSearch;
	            this.search = '';
	        }
	    }, {
	        key: 'resetPagination',
	        value: function resetPagination() {
	            this.tableOptions.page = 1;
	        }
	    }, {
	        key: 'getAgencies',
	        value: function getAgencies() {
	            var _this9 = this;

	            this.AgencyService.getAgencies().then(function (data) {
	                _this9.agencies = data;
	            }, function (error) {
	                _this9.toastr.error('Impossible de récupérer la liste des agences');
	                _this9.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'showResetGoogleInfosModal',
	        value: function showResetGoogleInfosModal(user) {
	            var _this10 = this;

	            var confirm = this.dialog.confirm({
	                title: 'Réinitialisation',
	                ok: 'Confirmer',
	                cancel: 'Annuler',
	                clickOutsideToClose: true,
	                htmlContent: '<div>\n                                <p>Confirmer la réinitilisation des informations suivantes :</p>\n                                <ul>\n                                    <li>Nom</li>\n                                    <li>Prénom</li>\n                                    <li>ID Google</li>\n                                    <li>Jeton d\'accès Google</li>\n                                </ul>\n                            </div>'
	            });

	            this.dialog.show(confirm).then(function () {
	                _this10.resetUserGoogleInfos(user);
	            });
	        }
	    }, {
	        key: 'resetUserGoogleInfos',
	        value: function resetUserGoogleInfos(user) {
	            user = Object.assign(user, {
	                first_name: null,
	                last_name: null,
	                google_id: null,
	                google_access_token: null
	            });

	            this.updateUser(user);
	        }
	    }]);

	    return UsersController;
	})();

	exports.UsersController = UsersController;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomersSpecificController = (function () {
	    CustomersSpecificController.$inject = ["$rootScope", "$scope", "$state", "$log", "$mdDialog", "toastr", "CustomerSpecificService", "SiteService"];
	    function CustomersSpecificController($rootScope, $scope, $state, $log, $mdDialog, toastr, CustomerSpecificService, SiteService) {
	        'ngInject';

	        _classCallCheck(this, CustomersSpecificController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.dialog = $mdDialog;
	        this.toastr = toastr;

	        this.CustomerSpecificService = CustomerSpecificService;
	        this.SiteService = SiteService;

	        this.tableOptions = { order: '-nb_sites', limit: 10, page: 1 };
	        this.selected = [];
	        this.newCustomerSpecific = {
	            email: null,
	            name: null,
	            civility: null
	        };
	        this.customersSpecific = [];
	        this.customers = [];
	        this.showSearch = false;
	        this.civilities = [{ id: 1, label: 'Mr' }, { id: 2, label: 'Mme' }];

	        this.activate();
	    }

	    _createClass(CustomersSpecificController, [{
	        key: 'getCivility',
	        value: function getCivility(id) {
	            return this.civilities.find(function (civility) {
	                return civility.id === id;
	            }).label;
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            this.getCustomersSpecific();
	            this.getAllSites();
	        }
	    }, {
	        key: 'getAllSites',
	        value: function getAllSites() {
	            var _this = this;

	            this.SiteService.getSites().then(function (success) {
	                _this.sites = success;
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des sites');
	                _this.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'getCustomersSpecific',
	        value: function getCustomersSpecific() {
	            var _this2 = this;

	            this.CustomerSpecificService.getCustomersSpecific().then(function (success) {
	                _this2.customersSpecific = success;
	                _this2.customerSpecificCount = success.length;
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer la liste des portails clients spécifiques');
	                _this2.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'addCustomerSpecific',
	        value: function addCustomerSpecific() {
	            var _this3 = this;

	            this.CustomerSpecificService.addCustomerSpecific(this.newCustomerSpecific).then(function () {
	                _this3.toastr.success('L\'utilisateur a été ajouté');
	                _this3.getCustomersSpecific();
	                _this3.newCustomerSpecific = {
	                    email: null,
	                    name: null,
	                    civility: null
	                };
	                _this3.$scope.customersSpecificForm.$setPristine();
	                _this3.$scope.customersSpecificForm.$setUntouched();
	            }, function (error) {
	                if (error.status === 400) {
	                    _this3.toastr.error('Adresse email déjà utilisée ');
	                } else {
	                    _this3.toastr.error('Impossible d\'ajouter l\'utilisateur');
	                }
	            });
	        }
	    }, {
	        key: 'filter',
	        value: function filter(query) {
	            var lowerCaseQuery = query ? query.toLowerCase() : '';
	            return function (value) {
	                return value.name.toLowerCase().includes(lowerCaseQuery) || value.email.toLowerCase().includes(lowerCaseQuery) || value.sites.find(function (site) {
	                    return site.quadra_id.toLowerCase().includes(lowerCaseQuery) || site.name.toLowerCase().includes(lowerCaseQuery) || site.customer.name.toLowerCase().includes(lowerCaseQuery);
	                });
	            };
	        }
	    }, {
	        key: 'editCustomerSpecific',
	        value: function editCustomerSpecific(customer) {
	            var _this4 = this;

	            var editedCustomerSpecific = angular.copy(customer);
	            var edit = this.dialog.confirm({
	                template: '<md-dialog aria-label="Édition d\'un portail" ng-cloak>\n                           <form class="edit-customer-specific-action" name="editCustomersSpecificForm">\n                               <md-toolbar>\n                                   <div class="md-toolbar-tools">\n                                       <h2>Édition d\'un portail</h2>\n                                       <span flex></span>\n                                       <md-button class="md-icon-button" ng-click="editCustomerSpecific.closeDialog()">\n                                           <md-icon aria-label="Close dialog">close</md-icon>\n                                       </md-button>\n                                   </div>\n                               </md-toolbar>\n                               <md-dialog-content>\n                                   <div class="md-dialog-content">\n                                       <md-input-container class="edit-customer">\n                                            <label>Adresse email</label>\n                                            <input\n                                                type="text" ng-model="editCustomerSpecific.customerSpecific.email"\n                                                pattern=".+@(?!agenor\\.fr).+"\n                                                name="email" required\n                                            >\n                                            <div class="error-message" ng-show="editCustomersSpecificForm.email.$error.pattern">\n                                                Erreur dans l’adresse email\n                                            </div>\n                                       </md-input-container>\n                                       <md-input-container class="md-block md-select">\n                                            <label>Civilité</label>\n                                            <md-select name="civility" ng-model="editCustomerSpecific.customerSpecific.civility">\n                                                <md-option ng-repeat="civility in editCustomerSpecific.civilities" value="{{civility.id}}">\n                                                    {{civility.label}}\n                                                </md-option>\n                                            </md-select>\n                                       </md-input-container>\n                                       <md-input-container class="add-customer">\n                                            <label>Nom</label>\n                                            <input type="text" ng-model="editCustomerSpecific.customerSpecific.name" name="customerName"\n                                            minlength="2" required\n                                            >\n                                            <div class="error-message" ng-show="editCustomersSpecificForm.customerName.$error.minlength">\n                                                Le nom doit comporter au moins 2 caractères\n                                            </div>\n                                       </md-input-container>\n                                   </div>\n                               </md-dialog-content>\n                               <md-dialog-actions layout="row">\n                                   <span flex></span>\n                                   <md-button ng-click="editCustomerSpecific.closeDialog()">Annuler</md-button>\n                                   <md-button ng-click="editCustomerSpecific.validDialog()" style="margin-right:20px;" ng-disabled="editCustomersSpecificForm.$invalid">Valider</md-button>\n                               </md-dialog-actions>\n                           </form>\n                        </md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'CustomerSpecificFormController',
	                controllerAs: 'editCustomerSpecific',
	                locals: {
	                    customerSpecific: editedCustomerSpecific
	                }
	            });

	            this.dialog.show(edit).then(function (data) {
	                _this4.updateCustomerSpecific(data);
	            });
	        }
	    }, {
	        key: 'updateCustomerSpecific',
	        value: function updateCustomerSpecific(customerSpecific) {
	            var _this5 = this;

	            var customerSpecificUpdated = {
	                email: customerSpecific.email,
	                name: customerSpecific.name,
	                civility: customerSpecific.civility,
	                active: customerSpecific.active
	            };

	            this.CustomerSpecificService.updateCustomerSpecific(customerSpecific.id, customerSpecificUpdated).then(function () {
	                _this5.toastr.success('L\'utilisateur ' + customerSpecific.email + ' a bien été mis à jour');
	                _this5.selected = [];
	                _this5.getCustomersSpecific();
	            }, function (error) {
	                if (error.status === 400) {
	                    _this5.toastr.error('Adresse email déjà utilisée ');
	                } else {
	                    _this5.toastr.error('Impossible de mettre à jour l\'utilisateur ' + customerSpecific.email);
	                }
	            });
	        }
	    }, {
	        key: 'duplicateCustomerSpecific',
	        value: function duplicateCustomerSpecific(customer) {
	            var _this6 = this;

	            var duplicatedCustomerSpecific = angular.copy(customer);
	            var duplicate = this.dialog.confirm({
	                template: '<md-dialog aria-label="Duplication d\'un portail" ng-cloak>\n                           <form class="duplicate-customer-specific-action" name="duplicateCustomersSpecificForm">\n                               <md-toolbar>\n                                   <div class="md-toolbar-tools">\n                                       <h2>Duplication du portail de\n                                       {{ duplicateCustomerSpecific.customerSpecific.civility\n                                            ? duplicateCustomerSpecific.getCivility(duplicateCustomerSpecific.customerSpecific.civility)\n                                        : \'\'}} {{duplicateCustomerSpecific.customerSpecific.name}}\n                                       </h2>\n                                       <span flex></span>\n                                       <md-button class="md-icon-button" ng-click="duplicateCustomerSpecific.closeDialog()">\n                                           <md-icon aria-label="Close dialog">close</md-icon>\n                                       </md-button>\n                                   </div>\n                               </md-toolbar>\n                               <md-dialog-content>\n                                   <div class="md-dialog-content">\n                                       <md-input-container class="duplicate-customer">\n                                            <label>Adresse email</label>\n                                            <input\n                                                type="text" ng-model="duplicateCustomerSpecific.customerSpecific.email"\n                                                pattern=".+@(?!agenor\\.fr).+"\n                                                name="email" required\n                                            >\n                                            <div class="error-message" ng-show="duplicateCustomersSpecificForm.email.$error.pattern">\n                                                Erreur dans l’adresse email\n                                            </div>\n                                       </md-input-container>\n                                       <md-input-container class="md-block md-select">\n                                            <label>Civilité</label>\n                                            <md-select name="civility" ng-model="duplicateCustomerSpecific.customerSpecific.civility">\n                                                <md-option ng-repeat="civility in duplicateCustomerSpecific.civilities" value="{{civility.id}}">\n                                                    {{civility.label}}\n                                                </md-option>\n                                            </md-select>\n                                       </md-input-container>\n                                       <md-input-container class="add-customer">\n                                            <label>Nom</label>\n                                            <input type="text" ng-model="duplicateCustomerSpecific.customerSpecific.name" name="customerName"\n                                            minlength="2" required\n                                            >\n                                            <div class="error-message" ng-show="duplicateCustomersSpecificForm.customerName.$error.minlength">\n                                                Le nom doit comporter au moins 2 caractères\n                                            </div>\n                                       </md-input-container>\n                                   </div>\n                               </md-dialog-content>\n                               <md-dialog-actions layout="row">\n                                   <span flex></span>\n                                   <md-button ng-click="duplicateCustomerSpecific.closeDialog()">Annuler</md-button>\n                                   <md-button ng-click="duplicateCustomerSpecific.validDialog()" style="margin-right:20px;" ng-disabled="duplicateCustomersSpecificForm.$invalid">Dupliquer</md-button>\n                               </md-dialog-actions>\n                           </form>\n                        </md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'CustomerSpecificFormController',
	                controllerAs: 'duplicateCustomerSpecific',
	                locals: {
	                    customerSpecific: duplicatedCustomerSpecific
	                }
	            });

	            this.dialog.show(duplicate).then(function (data) {
	                var customerSpecificUpdated = {
	                    email: data.email,
	                    name: data.name,
	                    civility: data.civility
	                };
	                _this6.CustomerSpecificService.duplicateCustomerSpecific(customer.id, customerSpecificUpdated).then(function () {
	                    _this6.toastr.success('L\'utilisateur ' + customer.email + ' a bien été duppliqué');
	                    _this6.selected = [];
	                    _this6.getCustomersSpecific();
	                }, function () {
	                    _this6.toastr.error('Adresse email déjà utilisée');
	                });
	            });
	        }
	    }, {
	        key: 'deleteCustomerSpecific',
	        value: function deleteCustomerSpecific(customerSpecific) {
	            var _this7 = this;

	            var remove = this.dialog.confirmModal({
	                locals: {
	                    title: "Suppression d’un portail client spécifique",
	                    content: 'Voulez-vous supprimer le portail ' + customerSpecific.email + ' ?',
	                    ok: "Supprimer"
	                }
	            });

	            this.dialog.show(remove, {
	                title: "Suppression d’un portail client spécifique"
	            }).then(function () {
	                _this7.CustomerSpecificService.deleteCustomerSpecific(customerSpecific.id).then(function () {
	                    _this7.toastr.success('L\'utilisateur ' + customerSpecific.email + ' a bien été supprimé');
	                    _this7.selected = [];
	                    _this7.getCustomersSpecific();
	                }, function () {
	                    _this7.toastr.error('Impossible de supprimer l\'utilisateur ' + customerSpecific.email);
	                });
	            });
	        }
	    }, {
	        key: 'editCustomerSpecificSites',
	        value: function editCustomerSpecificSites(customerSpecific) {
	            var _this8 = this;

	            var remove = this.dialog.confirm({
	                clickOutsideToClose: true,
	                templateUrl: 'app/views/content/rightManagment/customersSpecific/editCustomerSpecificSite/editCustomerSpecificSite.html',
	                controller: 'EditCustomerSpecificSiteController',
	                controllerAs: 'editCustomerSpecificSite',
	                locals: {
	                    customerSpecific: customerSpecific,
	                    sites: this.sites
	                }
	            });

	            this.dialog.show(remove).then(function (data) {
	                _this8.CustomerSpecificService.updateCustomerSpecific(customerSpecific.id, data).then(function () {
	                    _this8.toastr.success('L\'utilisateur ' + customerSpecific.email + ' a bien été mis à jour');
	                    _this8.selected = [];
	                    _this8.getCustomersSpecific();
	                }, function (error) {
	                    if (error.data.errors && error.data.errors.length > 0) {
	                        _this8.toastr.error(error.data.errors.join('\n'));
	                    } else {
	                        _this8.toastr.error('Impossible de mettre à jour l\'utilisateur ' + customerSpecific.email);
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'sendPasswordCustomerSpecific',
	        value: function sendPasswordCustomerSpecific(customerSpecific) {
	            var _this9 = this;

	            var email = this.dialog.confirmModal({
	                locals: {
	                    title: "Envoi des identifiants",
	                    content: 'Voulez vous envoyer les identifiants de connexion à ' + customerSpecific.email + ' ?',
	                    ok: "Envoyer"
	                }
	            });

	            this.dialog.show(email).then(function () {
	                _this9.CustomerSpecificService.sendPasswordCustomerSpecific(customerSpecific.id).then(function () {
	                    _this9.toastr.success('L\'utilisateur ' + customerSpecific.email + ' a bien été notifié');
	                    _this9.selected = [];
	                    _this9.getCustomersSpecific();
	                }, function () {
	                    _this9.toastr.error('Impossible de contacter l\'utilisateur ' + customerSpecific.email);
	                });
	            });
	        }
	    }, {
	        key: 'toggleSearch',
	        value: function toggleSearch() {
	            this.showSearch = !this.showSearch;
	            this.search = '';
	        }
	    }, {
	        key: 'resetPagination',
	        value: function resetPagination() {
	            this.tableOptions.page = 1;
	        }
	    }]);

	    return CustomersSpecificController;
	})();

	exports.CustomersSpecificController = CustomersSpecificController;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditUserRoleController = (function () {
	    EditUserRoleController.$inject = ["$state", "$scope", "user", "roles", "$mdDialog"];
	    function EditUserRoleController($state, $scope, user, roles, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, EditUserRoleController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.user = user;
	        this.roles = roles;
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.activate();
	    }

	    _createClass(EditUserRoleController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.user);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditUserRoleController;
	})();

	exports.EditUserRoleController = EditUserRoleController;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomersController = (function () {
	    CustomersController.$inject = ["$rootScope", "$scope", "$state", "$log", "toastr", "CustomerService"];
	    function CustomersController($rootScope, $scope, $state, $log, toastr, CustomerService) {
	        'ngInject';

	        _classCallCheck(this, CustomersController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$log = $log;
	        this.toastr = toastr;

	        this.CustomerService = CustomerService;

	        this.tableOptions = { order: 'contact.last_name', limit: 20, page: 1 };

	        this.activate();
	    }

	    _createClass(CustomersController, [{
	        key: 'activate',
	        value: function activate() {
	            var _this = this;

	            this.getCustomers(this.tableOptions.page, this.tableOptions.limit);
	            this.getCustomersCount();

	            this.onPagination = function (page, limit) {
	                _this.CustomerService.getCustomers(page, limit).then(function (data) {
	                    _this.customers = data;
	                    /*angular.forEach(data, (elem) => {
	                        angular.forEach(elem.sites, (contact) => {
	                            this.customers.push(contact);
	                        })
	                    });*/
	                    //this.customerCount = this.customers.length;
	                }, function (error) {
	                    _this.toastr.error('Impossible de récupérer la liste des clients');
	                    _this.$log.debug(error);
	                });
	            };
	        }
	    }, {
	        key: 'getCustomers',
	        value: function getCustomers(page, limit) {
	            var _this2 = this;

	            this.CustomerService.getCustomers(page, limit).then(function (data) {
	                _this2.customers = data;
	                /*angular.forEach(data, (elem) => {
	                    angular.forEach(elem.sites, (contact) => {
	                        this.customers.push(contact);
	                    })
	                });*/
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer la liste des clients');
	                _this2.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'getCustomersCount',
	        value: function getCustomersCount() {
	            var _this3 = this;

	            this.CustomerService.getCustomersCount().then(function (success) {
	                _this3.customerCount = success.customersCount;
	            }, function () {
	                _this3.toastr.error('Impossible de récupérer le nombre de site');
	            });
	        }
	    }]);

	    return CustomersController;
	})();

	exports.CustomersController = CustomersController;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var HistoryLogController = (function () {
	    HistoryLogController.$inject = ["$log", "toastr", "HistoryLogService"];
	    function HistoryLogController($log, toastr, HistoryLogService) {
	        'ngInject';

	        _classCallCheck(this, HistoryLogController);

	        this.$log = $log;
	        this.toastr = toastr;

	        this.HistoryLogService = HistoryLogService;

	        this.activate();
	    }

	    _createClass(HistoryLogController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getQuadraLogs();
	        }
	    }, {
	        key: 'getQuadraLogs',
	        value: function getQuadraLogs() {
	            var _this = this;

	            this.HistoryLogService.getQuadraLogs().then(function (data) {
	                _this.quadraLogs = data;
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des logs');
	                _this.$log.debug(error);
	            });
	        }
	    }]);

	    return HistoryLogController;
	})();

	exports.HistoryLogController = HistoryLogController;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var SatisfactionSurveyController = (function () {
	    function SatisfactionSurveyController() {
	        'ngInject';

	        _classCallCheck(this, SatisfactionSurveyController);

	        this.actualForms = {};

	        this.activate();
	    }

	    _createClass(SatisfactionSurveyController, [{
	        key: 'activate',
	        value: function activate() {}
	    }]);

	    return SatisfactionSurveyController;
	})();

	exports.SatisfactionSurveyController = SatisfactionSurveyController;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SeeAllController = (function () {
	  SeeAllController.$inject = ["$log", "$mdDialog", "toastr", "SatisfactionSurveyService"];
	  function SeeAllController($log, $mdDialog, toastr, SatisfactionSurveyService) {
	    'ngInject';

	    _classCallCheck(this, SeeAllController);

	    this.dialog = $mdDialog;
	    this.$log = $log;
	    this.toastr = toastr;

	    this.satisfactionSurveyService = SatisfactionSurveyService;
	    this.surveys = {};
	    this.questions = {};
	    this.questionTypes = [{ "id": 1, "label": "Réponse libre" }, { "id": 2, "label": "Note sur 10" }, { "id": 3, "label": "Choix multiple" }, { "id": 4, "label": "Choix unique" }];

	    this.newSurvey = {};

	    this.activate();
	  }

	  _createClass(SeeAllController, [{
	    key: "activate",
	    value: function activate() {
	      this.getAllForms();
	      this.getQuestions();
	      this.getQuestionTypes();
	    }
	  }, {
	    key: "getAllForms",
	    value: function getAllForms() {
	      var _this = this;

	      this.satisfactionSurveyService.getAllForms().then(function (data) {
	        _this.surveys = data;
	        _.each(_this.surveys, function (item) {
	          item.visible = false;
	        });
	      }, function (error) {
	        _this.toastr.error('Impossible de récupérer les enquêtes');
	        _this.$log.debug(error);
	      });
	    }
	  }, {
	    key: "activeForm",
	    value: function activeForm(survey) {
	      var _this2 = this;

	      /*let survey = _.findWhere(this.surveys, {id: idSurvey});*/
	      survey.active = !survey.active;
	      this.satisfactionSurveyService.patchFormId(survey.id, { active: survey.active }).then(function (data) {
	        survey = data.plain();
	      }, function (error) {
	        _this2.toastr.error('Impossible de récupérer l\'enquête');
	        survey.active = !survey.active;
	        _this2.$log.debug(error);
	      });
	    }
	  }, {
	    key: "getQuestions",
	    value: function getQuestions() {
	      var _this3 = this;

	      _.each(this.surveys, function (item) {
	        _this3.satisfactionSurveyService.getAllQuestionWithFormId(item.id).then(function (data) {
	          var survey = _.findWhere(_this3.surveys, { id: item.id });
	          survey.visible = false;
	          _this3.questions[item.id] = data;
	        }, function (error) {
	          _this3.toastr.error('Impossible de récupérer l\'enquête');
	          _this3.$log.debug(error);
	        });
	      });
	    }
	  }, {
	    key: "getQuestionTypes",
	    value: function getQuestionTypes() {
	      var _this4 = this;

	      this.satisfactionSurveyService.getQuestionTypes().then(function (data) {
	        _this4.questionTypes = data;
	      }, function () {});
	    }
	  }, {
	    key: "showQuestions",
	    value: function showQuestions(idSurvey) {
	      var survey = _.find(this.surveys, { 'id': idSurvey });
	      if (survey.pages) {
	        survey.visible = true;
	      } else {
	        this.satisfactionSurveyService.getSurveyById(idSurvey).then(function (data) {
	          survey.pages = data.pages;
	          survey.visible = true;
	        }, function () {});
	      }
	    }
	  }, {
	    key: "deleteForm",
	    value: function deleteForm(idSurvey) {
	      var _this5 = this;

	      this.satisfactionSurveyService.removeSurvey(idSurvey).then(function () {
	        _this5.surveys = _.reject(_this5.surveys, { 'id': idSurvey });
	        _this5.toastr.success('l\'enquête de satisfaction à bien été supprimée');
	        //this.getQuestions();
	      }, function (error) {
	        _this5.toastr.error('Impossible de supprimer l\'enquête');
	        _this5.$log.debug(error);
	      });
	    }
	  }, {
	    key: "createForm",
	    value: function createForm(form) {
	      this.newSurvey.name = form.form_name;
	      this.newSurvey.active = false;
	      this.newSurvey.visible = true;
	      this.newSurvey.pages = [{ order: 1, questions: [] }];

	      this.surveys.splice(0, 0, this.newSurvey);
	    }
	  }, {
	    key: "createQuestion",
	    value: function createQuestion(idForm, dataQuestion) {
	      var _this6 = this;

	      var self = this;
	      this.satisfactionSurveyService.createQuestion(idForm, dataQuestion).then(function (data) {
	        self.questions[idForm].push(data.plain());
	      }, function (error) {
	        _this6.toastr.error('Impossible de supprimer l\'enquête');
	        _this6.$log.debug(error);
	      });
	    }
	  }, {
	    key: "updateQuestion",
	    value: function updateQuestion(idSurvey, data) {
	      var _this7 = this;

	      var myData = {
	        form_order: data.form_order,
	        form_options: data.form_options
	      };
	      var self = this;
	      this.satisfactionSurveyService.patchQuestionId(data.id, myData).then(function (data) {
	        var question = _.findWhere(self.questions[idSurvey], { id: data.id });
	        angular.copy(data, question);
	      }, function (error) {
	        _this7.toastr.error('Impossible de supprimer l\'enquête');
	        _this7.$log.debug(error);
	      });
	    }
	  }, {
	    key: "deleteQuestion",
	    value: function deleteQuestion(data) {
	      var _this8 = this;

	      this.satisfactionSurveyService.deleteQuestion(data.form.id, data.id).then(function () {
	        _this8.questions[data.form.id] = _.reject(_this8.questions[data.form.id], function (item) {
	          return item.id == data.id;
	        });
	      }, function (error) {
	        _this8.toastr.error('Impossible de supprimer la question');
	        _this8.$log.debug(error);
	      });
	    }

	    /*
	    * ADD NEW PAGE IN SURVEY
	    */

	  }, {
	    key: "addNewSurveyPage",
	    value: function addNewSurveyPage(survey) {
	      var newPage = {
	        order: survey.pages.length + 1,
	        questions: []
	      };

	      survey.pages.push(newPage);
	    }

	    /*
	     * MODAL
	     */

	  }, {
	    key: "showDeleteAllModal",
	    value: function showDeleteAllModal(idForm) {
	      var _this9 = this;

	      var confirm = this.dialog.confirm().title('Suppression').textContent('Confirmer la suppression du formulaire (questions et reponses seront supprimées)').clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');

	      this.dialog.show(confirm).then(function () {
	        _this9.deleteForm(idForm);
	      });
	    }
	  }, {
	    key: "showCreateNewFormModal",
	    value: function showCreateNewFormModal() {
	      var _this10 = this;

	      var edit = this.dialog.confirm({
	        template: '<md-dialog aria-label="Création de l\'enquête" ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Création d\'une enquête</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="createSurvey.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <input type="text" ng-model="createSurvey.survey.form_name" required ng-change="createSurvey.isNotEmpty()">' + '                   <span class="error-message" ng-show="createSurvey.disabled">Ce champ est obligatoire</span>' + '                   <label>Nom de l\'enquête</label>' + '               </md-input-container>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="createSurvey.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="createSurvey.validDialog()" style="margin-right:20px;" ng-disabled="createSurvey.disabled">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	        clickOutsideToClose: true,
	        controller: 'CreateSurveyController',
	        controllerAs: 'createSurvey',
	        locals: {
	          survey: {}
	        }
	      });
	      this.dialog.show(edit).then(function (data) {
	        _this10.createForm(data);
	      }, function () {});
	    }
	  }, {
	    key: "showCreateNewQuestionModal",
	    value: function showCreateNewQuestionModal(page) {
	      var edit = this.dialog.confirm({
	        template: '<md-dialog aria-label="Ajout d\'une question" ng-cloak class="width-fixed">' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Création d\'une question</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="createQuestion.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '               <md-select aria-label="type de question" name="form_type" ng-model="createQuestion.question.type">' + '                   <md-option ng-repeat="type in createQuestion.types" ng-value="{{type.id}}">{{type.label}}</md-option>' + '               </md-select>' + '               <label>Type</label>' + '               </md-input-container>' + '               <md-input-container>' + '                   <input type="text" ng-model="createQuestion.question.order" required ng-change="createQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="createQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Ordre</label>' + '               </md-input-container>' + '               <md-input-container>' + '                   <input type="text" ng-model="createQuestion.question.options.label" required ng-change="createQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="createQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Question</label>' + '               </md-input-container>' + '               <md-input-container ng-if="createQuestion.question.type === 2">' + '                   <input type="number" ng-model="createQuestion.question.coefficient" required ng-change="createQuestion.isInteger()">' + '                   <span class="error-message" ng-show="createQuestion.disabled">Ce champ est obligatoire</span>' + '                   <span class="error-message" ng-show="createQuestion.question.invalidInteger">Ce champ doit être un nombre entier</span>' + '                   <label>Coefficient</label>' + '               </md-input-container>' + '               <md-input-container ng-if="createQuestion.question.type === 3 || createQuestion.question.type === 4" ng-repeat="choice in createQuestion.question.options.choices track by $index">' + '                   <input type="text" ng-model="createQuestion.question.options.choices[$index]" required ng-change="createQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="createQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Choix {{$index}}</label>' + '               </md-input-container>' + '               <md-button ng-if="createQuestion.question.type === 3 || createQuestion.question.type === 4" ng-click="createQuestion.addChoice()">Ajouter</md-button>' + '               <md-button ng-if="createQuestion.question.type === 3 || createQuestion.question.type === 4" ng-click="createQuestion.deleteChoice()">Supprimer</md-button>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="createQuestion.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="createQuestion.validDialog()" style="margin-right:20px;" ng-disabled="createQuestion.disabled || createQuestion.question.invalidInteger">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	        clickOutsideToClose: true,
	        controller: 'CreateQuestionController',
	        controllerAs: 'createQuestion',
	        locals: {
	          types: this.questionTypes,
	          question: {
	            "order": page.questions.length + 1
	          }
	        }
	      });
	      this.dialog.show(edit).then(function (data) {
	        if (data.type === 2) {
	          data.options.choices = {
	            "0": "0",
	            "1": "1",
	            "2": "2",
	            "3": "3",
	            "4": "4",
	            "5": "5",
	            "6": "6",
	            "7": "7",
	            "8": "8",
	            "9": "9",
	            "10": "10"
	          };
	          page.questions.push(data);
	        } else {

	          page.questions.push(data);
	        }
	      }, function () {});
	    }
	  }, {
	    key: "saveSurvey",
	    value: function saveSurvey(survey) {
	      var _this11 = this;

	      var surv = angular.copy(survey);
	      var surveyToUpdate = false;
	      var surveyId = survey.id;

	      if (surv.id) {
	        surveyToUpdate = true;
	      }

	      delete surv.created_at;
	      delete surv.updated_at;
	      delete surv.id;
	      delete surv.visible;

	      _.forEach(surv.pages, function (page) {
	        delete page.id;
	        delete page.created_at;
	        delete page.updated_at;

	        _.forEach(page.questions, function (question) {
	          delete question.created_at;
	          delete question.updated_at;
	          delete question.id;
	          delete question.type_name;
	        });
	      });

	      if (surveyToUpdate) {
	        this.satisfactionSurveyService.patchFormId(surveyId, surv).then(function (data) {
	          data.visible = false;
	          var idx = undefined;
	          idx = _.findIndex(_this11.surveys, { 'id': surveyId });
	          _this11.surveys.splice(idx, 1);
	          _this11.surveys.splice(idx, 0, data);
	        }, function () {});
	      } else {
	        this.satisfactionSurveyService.createForm(surv).then(function (data) {
	          data.visible = false;
	          var idx = undefined;
	          idx = _.findIndex(_this11.surveys, { 'name': data.name });
	          _this11.surveys.splice(idx, 1);
	          _this11.surveys.splice(0, 0, data);
	        }, function () {});
	      }
	    }
	  }, {
	    key: "showEditQuestionModal",
	    value: function showEditQuestionModal(question, surveyId, pageId) {
	      var _this12 = this;

	      var modifiedQuestion = angular.copy(question);
	      var edit = undefined;
	      if (question.type === 3 || question.type === 4) {
	        edit = this.dialog.confirm({
	          template: '<md-dialog aria-label="Edition du formulaire"  ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Edition de la question {{editQuestion.question.options.label}}</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button md-button-custom" ng-click="editQuestion.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.order" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Ordre</label>' + '               </md-input-container>' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.options.label" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Question</label>' + '               </md-input-container>' + '               <md-input-container ng-repeat="choice in editQuestion.question.options.choices track by $index">' + '                   <input type="text" ng-model="editQuestion.question.options.choices[$index]" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Choix {{$index}}</label>' + '               </md-input-container>' + '               <md-button ng-click="editQuestion.addChoice()">Ajouter</md-button>' + '               <md-button ng-click="editQuestion.deleteChoice()">Supprimer</md-button>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="editQuestion.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="editQuestion.validDialog()" style="margin-right:20px;" ng-disabled="editQuestion.disabled">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	          clickOutsideToClose: true,
	          controller: 'EditQuestionController',
	          controllerAs: 'editQuestion',
	          locals: {
	            question: modifiedQuestion
	          }
	        });
	      }
	      if (question.type === 2) {
	        edit = this.dialog.confirm({
	          template: '<md-dialog aria-label="Edition du formulaire"  ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Edition de la question {{editQuestion.question.options.label}}</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="editQuestion.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.order" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Ordre</label>' + '               </md-input-container>' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.options.label" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Question</label>' + '               </md-input-container>' + '               <md-input-container ng-if="editQuestion.question.type === 2">' + '                   <input type="number" ng-model="editQuestion.question.coefficient" required ng-change="editQuestion.isInteger()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <span class="error-message" ng-show="editQuestion.question.invalidInteger">Ce champ doit être un nombre entier</span>' + '                   <label>Coefficient</label>' + '               </md-input-container>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="editQuestion.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="editQuestion.validDialog()" style="margin-right:20px;" ng-disabled="editQuestion.disabled || editQuestion.question.invalidInteger">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	          clickOutsideToClose: true,
	          controller: 'EditQuestionController',
	          controllerAs: 'editQuestion',
	          locals: {
	            question: modifiedQuestion
	          }
	        });
	      }
	      if (question.type === 1) {
	        edit = this.dialog.confirm({
	          template: '<md-dialog aria-label="Edition du formulaire"  ng-cloak>' + '   <form>' + '       <md-toolbar>' + '           <div class="md-toolbar-tools">' + '               <h2>Edition de la question {{editQuestion.question.options.label}}</h2>' + '               <span flex></span>' + '               <md-button class="md-icon-button" ng-click="editQuestion.closeDialog()">' + '                   <md-icon aria-label="Close dialog">close</md-icon>' + '               </md-button>' + '           </div>' + '       </md-toolbar>' + '       <md-dialog-content>' + '           <div class="md-dialog-content">' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.order" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Ordre</label>' + '               </md-input-container>' + '               <md-input-container>' + '                   <input type="text" ng-model="editQuestion.question.options.label" required ng-change="editQuestion.isNotEmpty()">' + '                   <span class="error-message" ng-show="editQuestion.disabled">Ce champ est obligatoire</span>' + '                   <label>Question</label>' + '               </md-input-container>' + '           </div>' + '       </md-dialog-content>' + '       <md-dialog-actions layout="row">' + '           <span flex></span>' + '           <md-button ng-click="editQuestion.closeDialog()">Annuler</md-button>' + '           <md-button ng-click="editQuestion.validDialog()" style="margin-right:20px;" ng-disabled="editQuestion.disabled">Valider</md-button>' + '       </md-dialog-actions>' + '   </form>' + '</md-dialog>',
	          clickOutsideToClose: true,
	          controller: 'EditQuestionController',
	          controllerAs: 'editQuestion',
	          locals: {
	            question: modifiedQuestion
	          }
	        });
	      }
	      this.dialog.show(edit).then(function (data) {
	        var survey = _.find(_this12.surveys, { 'id': surveyId });
	        var page = _.find(survey.pages, { 'id': pageId });
	        var editedQuestion = angular.isDefined(question.id) ? _.find(page.questions, { 'id': question.id }) : _.find(page.questions, { 'order': data.order });

	        editedQuestion.options.label = data.options.label;
	        editedQuestion.order = data.order;
	        if (question.type === 3 || question.type === 4) {
	          editedQuestion.options.choices = data.options.choices;
	        }
	        if (question.type === 2) {
	          editedQuestion.coefficient = data.coefficient;
	        }
	      }, function () {});
	    }
	  }, {
	    key: "showDeleteQuestionModal",
	    value: function showDeleteQuestionModal(question) {
	      var _this13 = this;

	      var confirm = this.dialog.confirm().title('Suppression').textContent('Confirmer la suppression de la question (attention les réponses seront aussi supprimées) : ' + question.id).clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');
	      this.dialog.show(confirm).then(function () {
	        _this13.deleteQuestion(question);
	      });
	    }
	  }]);

	  return SeeAllController;
	})();

	exports.SeeAllController = SeeAllController;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CreateSurveyController = (function () {
	    CreateSurveyController.$inject = ["survey", "$mdDialog"];
	    function CreateSurveyController(survey, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, CreateSurveyController);

	        this.survey = survey;
	        this.dialog = $mdDialog;
	        this.disabled = true;
	        this.activate();
	    }

	    _createClass(CreateSurveyController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'isNotEmpty',
	        value: function isNotEmpty() {
	            this.disabled = this.survey.form_name == undefined;
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.survey);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return CreateSurveyController;
	})();

	exports.CreateSurveyController = CreateSurveyController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CreateQuestionController = (function () {
	    CreateQuestionController.$inject = ["question", "types", "$mdDialog"];
	    function CreateQuestionController(question, types, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, CreateQuestionController);

	        this.question = question;
	        this.types = types;
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.invalidInteger = false;
	        this.activate();
	    }

	    _createClass(CreateQuestionController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'addChoice',
	        value: function addChoice() {
	            if (this.question.options.choices == undefined) {
	                this.question.options.choices = [];
	            }

	            this.question.options.choices.push('');
	        }
	    }, {
	        key: 'deleteChoice',
	        value: function deleteChoice() {
	            this.question.options.choices.splice(this.question.options.choices.length - 1, 1);
	        }
	    }, {
	        key: 'isNotEmpty',
	        value: function isNotEmpty() {
	            this.disabled = false;
	        }
	    }, {
	        key: 'isInteger',
	        value: function isInteger() {
	            this.invalidInteger = Number.isInteger(this.question.coefficient) ? false : true;
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.question);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return CreateQuestionController;
	})();

	exports.CreateQuestionController = CreateQuestionController;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EditQuestionController = (function () {
	    EditQuestionController.$inject = ["question", "$mdDialog"];
	    function EditQuestionController(question, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, EditQuestionController);

	        this.question = question;
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.invalidInteger = false;
	        this.activate();
	    }

	    _createClass(EditQuestionController, [{
	        key: "addChoice",
	        value: function addChoice() {
	            this.question.options.choices.push("");
	        }
	    }, {
	        key: "deleteChoice",
	        value: function deleteChoice() {
	            this.question.options.choices.splice(this.question.options.choices.length - 1, 1);
	        }
	    }, {
	        key: "activate",
	        value: function activate() {}
	    }, {
	        key: "isInteger",
	        value: function isInteger() {
	            this.invalidInteger = Number.isInteger(this.question.coefficient) ? false : true;
	        }
	    }, {
	        key: "isNotEmpty",
	        value: function isNotEmpty() {
	            if (this.question.order != undefined) {
	                this.disabled = false;
	            } else {
	                this.disabled = true;
	            }
	        }
	    }, {
	        key: "validDialog",
	        value: function validDialog() {
	            this.dialog.hide(this.question);
	        }
	    }, {
	        key: "closeDialog",
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditQuestionController;
	})();

	exports.EditQuestionController = EditQuestionController;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _lodash = __webpack_require__(50);

	var _ = _interopRequireWildcard(_lodash);

	var SeeAnswerController = (function () {
	  SeeAnswerController.$inject = ["$log", "$mdDialog", "toastr", "SatisfactionSurveyService"];
	  function SeeAnswerController($log, $mdDialog, toastr, SatisfactionSurveyService) {
	    'ngInject';

	    _classCallCheck(this, SeeAnswerController);

	    this.dialog = $mdDialog;
	    this.$log = $log;
	    this.toastr = toastr;

	    this.satisfactionSurveyService = SatisfactionSurveyService;
	    this.answers = {};
	    this.currentActiveSurvey = null;

	    this.activate();
	  }

	  _createClass(SeeAnswerController, [{
	    key: 'activate',
	    value: function activate() {
	      this.getAllForms();
	      //this.getAnswers();
	    }
	  }, {
	    key: 'getAllForms',
	    value: function getAllForms() {
	      var _this = this;

	      this.satisfactionSurveyService.getAllForms().then(function (data) {
	        _this.surveys = data;
	        _.each(_this.surveys, function (item) {
	          item.visible = false;
	        });
	      }, function (error) {
	        _this.toastr.error('Impossible de récupérer les enquêtes');
	        _this.$log.debug(error);
	      });
	    }
	  }, {
	    key: 'showSurveyAnwsers',
	    value: function showSurveyAnwsers(idSurvey) {
	      var _this2 = this;

	      this.currentActiveSurvey = idSurvey;
	      var survey = _.find(this.surveys, { 'id': idSurvey });
	      if (survey.answers) {
	        survey.visible = true;
	      } else {
	        this.satisfactionSurveyService.getAnswers(idSurvey).then(function (data) {
	          survey.pages = data.pages;
	          survey.visible = true;
	        }, function (error) {
	          _this2.toastr.error('Impossible d\'afficher les réponses.');
	          _this2.$log.debug(error);
	        });
	      }
	    }
	  }, {
	    key: 'getAnswers',
	    value: function getAnswers() {
	      var _this3 = this;

	      var temp = [];
	      //let currentForm = 0;
	      this.satisfactionSurveyService.getAnswers().then(function (data) {
	        _this3.answers = data;
	        _.each(data, function (item) {
	          if (!_.findWhere(temp, { id: item.dynamic_form_question.form.id })) {
	            temp.push({
	              id: item.dynamic_form_question.form.id,
	              survey_name: item.dynamic_form_question.form.form_name,
	              customers: [],
	              visible: false
	            });
	          }
	          var dynamicForm = _.findWhere(temp, { id: item.dynamic_form_question.form.id });
	          if (!_.findWhere(dynamicForm.customers, { id: item.customer.id })) {
	            dynamicForm.customers.push({
	              id: item.customer.id,
	              name: item.customer.name,
	              survey_questions: [],
	              visible: false
	            });
	          }
	          var customer = _.findWhere(dynamicForm.customers, { id: item.customer.id });
	          if (!_.findWhere(customer.survey_questions, { created_at: item.created_at })) {
	            customer.survey_questions.push({
	              created_at: item.created_at,
	              visible: false,
	              questions: []
	            });
	          }
	          var question = _.findWhere(customer.survey_questions, { created_at: item.created_at });
	          if (!_.findWhere(customer.questions, { id: item.dynamic_form_question.id })) {
	            var theAnswer = undefined;
	            if (item.dynamic_form_question.form_type == 3) {
	              theAnswer = item.dynamic_form_question.form_options.choices[item.answer];
	            } else {
	              theAnswer = item.answer;
	            }
	            question.questions.push({
	              id: item.dynamic_form_question.id,
	              question: item.dynamic_form_question.form_options.label,
	              answer: theAnswer
	            });
	          }
	        });
	        angular.copy(temp, _this3.answers);
	      }, function (error) {
	        _this3.toastr.error('Impossible de récupérer les reponses');
	        _this3.$log.debug(error);
	      });
	    }
	  }, {
	    key: 'showSurvey',
	    value: function showSurvey(id) {
	      var temp = _.findWhere(this.answers, { id: id });
	      temp.visible = temp.visible == false;
	    }
	  }, {
	    key: 'showSurveyDate',
	    value: function showSurveyDate(id, clientId, createdAt) {
	      var temp = _.findWhere(this.answers, { id: id });
	      var temp2 = _.findWhere(temp.customers, { id: clientId });
	      var temp3 = _.findWhere(temp2.survey_questions, { created_at: createdAt });
	      temp3.visible = temp3.visible == false;
	    }
	  }, {
	    key: 'showSurveyClient',
	    value: function showSurveyClient(id, clientId) {
	      var temp = _.findWhere(this.answers, { id: id });
	      var temp2 = _.findWhere(temp.customers, { id: clientId });
	      temp2.visible = temp2.visible == false;
	    }
	  }]);

	  return SeeAnswerController;
	})();

	exports.SeeAnswerController = SeeAnswerController;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';

	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;

	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;

	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);

	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;

	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;

	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };

	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };

	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;

	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;

	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }

	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;

	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }

	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;

	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }

	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }

	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }

	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;

	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;

	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');

	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;

	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }

	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }

	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }

	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }

	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }

	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;

	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }

	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

	      return result ? 0 : -1;
	    }

	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);

	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;

	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;

	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);

	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }

	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;

	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;

	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;

	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }

	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }

	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;

	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);

	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);

	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }

	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;

	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);

	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];

	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;

	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];

	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;

	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;

	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);

	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }

	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;

	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);

	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

	      stackA.pop();
	      stackB.pop();

	      return result;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];

	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');

	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);

	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;

	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];

	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;

	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);

	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }

	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }

	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;

	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;

	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];

	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;

	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;

	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }

	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);

	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;

	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }

	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);

	      view.set(new Uint8Array(buffer));
	      return result;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);

	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;

	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;

	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;

	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }

	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';

	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }

	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }

	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }

	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }

	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);

	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }

	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }

	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }

	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }

	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }

	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }

	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }

	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);

	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;

	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);

	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;

	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);

	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }

	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');

	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;

	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }

	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }

	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }

	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;

	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);

	      var index = -1,
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;

	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());

	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;

	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));

	      var index = -1,
	          result = [];

	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }

	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }

	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }

	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];

	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];

	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];

	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;

	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];

	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);

	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;

	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }

	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;

	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }

	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);

	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};

	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;

	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }

	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });

	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;

	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }

	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }

	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }

	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });

	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }

	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;

	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];

	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);

	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }

	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });

	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

	      var index = -1,
	          length = methodNames.length;

	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }

	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }

	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }

	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }

	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);

	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;

	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });

	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }

	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);

	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }

	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }

	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }

	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }

	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }

	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }

	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;

	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });

	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);

	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);

	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);

	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index],
	            value = object[key];

	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;

	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;

	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);

	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });

	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);

	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }

	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });

	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }

	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);

	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }

	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;

	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });

	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }

	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);

	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }

	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;

	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);

	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);

	      return result;
	    }

	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

	      return string.lastIndexOf(target, position) == position;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);

	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }

	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }

	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;

	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];

	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);

	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }

	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);

	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);

	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }

	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }

	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);

	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);

	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }

	    /*------------------------------------------------------------------------*/

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;

	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;

	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;

	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;

	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;

	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);

	    /*------------------------------------------------------------------------*/

	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;

	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;

	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };

	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;

	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });

	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });

	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);

	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;

	    return lodash;
	  }

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)(module), (function() { return this; }())))

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CockpitController = (function () {
	    CockpitController.$inject = ["CockpitService", "CreateFileService", "toastr", "$log", "$mdDialog", "moment", "$scope"];
	    function CockpitController(CockpitService, CreateFileService, toastr, $log, $mdDialog, moment, $scope) {
	        'ngInject';

	        _classCallCheck(this, CockpitController);

	        this.CockpitService = CockpitService;
	        this.CreateFileService = CreateFileService;
	        this.toastr = toastr;
	        this.$log = $log;
	        this.dialog = $mdDialog;
	        this.$scope = $scope;
	        this.moment = moment;
	        this.dateNow = this.moment(this.moment().valueOf()).format('YYYY-MM-DD');
	        this.dataForm = {};
	    }

	    _createClass(CockpitController, [{
	        key: 'downloadCSVAgecomAppli',
	        value: function downloadCSVAgecomAppli() {
	            var _this = this;

	            var filename = 'cockpit_agecom_appli_' + this.dateNow + '.csv';

	            this.CockpitService.getCSVAgecomAppli().then(function (content) {
	                _this.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	            });
	        }
	    }, {
	        key: 'downloadCSVCustomerPortail',
	        value: function downloadCSVCustomerPortail() {
	            var _this2 = this;

	            var filename = 'cockpit_cusotmer_portal_' + this.dateNow + '.csv';

	            this.CockpitService.getCSVCustomerPortal().then(function (content) {
	                _this2.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	            });
	        }
	    }, {
	        key: 'downloadCSVCustomerPortailV2',
	        value: function downloadCSVCustomerPortailV2() {
	            var _this3 = this;

	            var filename = 'cockpit_cusotmer_portal_V2_' + this.dateNow + '.csv';

	            this.CockpitService.getCSVCustomerPortalV2().then(function (content) {
	                _this3.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	            });
	        }
	    }, {
	        key: 'openCSVAgecomSynchroModal',
	        value: function openCSVAgecomSynchroModal() {
	            var _this4 = this;

	            var form = this.dialog.confirm({
	                template: '<md-dialog aria-label="Choix des dates pour le téléchargement du fichier">\n' + '    <form name="form">\n' + '        <md-toolbar>\n' + '            <div class="md-toolbar-tools">\n' + '                <h2>Choix des dates pour le téléchargement</h2>\n' + '                <span flex></span>\n' + '                <md-button class="md-icon-button" ng-click="formDialog.closeDialog()">\n' + '                    <md-icon aria-label="Close dialog">close</md-icon>\n' + '                </md-button>\n' + '            </div>\n' + '        </md-toolbar>\n' + '        <md-dialog-content>\n' + '            <div class="md-dialog-content">\n' + '                <md-input-container>\n' + '                    <input name="dtStart" type="text" ng-model="formDialog.dataForm.dtStart" placeholder="Date de début" ng-pattern="formDialog.regex">\n' + '                </md-input-container>\n' + '                <md-input-container>\n' + '                    <input name="dtEnd" type="text" ng-model="formDialog.dataForm.dtEnd" placeholder="Date de fin" ng-pattern="formDialog.regex">\n' + '                </md-input-container>\n' + '            </div>\n' + '        </md-dialog-content>\n' + '        <md-dialog-actions layout="row">\n' + '            <span flex></span>\n' + '            <md-button ng-click="formDialog.closeDialog()">Annuler</md-button>\n' + '            <md-button ng-click="formDialog.validDialog()" style="margin-right:20px;" ng-disabled="!(form.dtStart.$valid && form.dtEnd.$valid)">Télécharger</md-button>\n' + '        </md-dialog-actions>\n' + '    </form>\n' + '</md-dialog>',
	                clickOutsideToClose: true,
	                controller: 'FormDialogController',
	                controllerAs: 'formDialog'
	            });

	            this.dialog.show(form).then(function (data) {
	                var dtStart = data.dtStart;
	                var dtEnd = data.dtEnd;
	                var filename = 'cockpit_agecom_synchro_' + dtStart + '_' + dtEnd + '.csv';

	                _this4.CockpitService.getCSVAgecomSynchro(dtStart, dtEnd).then(function (content) {
	                    _this4.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	                });
	            }, function () {});
	        }
	    }, {
	        key: 'downloadCSVControlQualityRelevance',
	        value: function downloadCSVControlQualityRelevance() {
	            var _this5 = this;

	            var filename = 'cockpit_pertinence_' + this.dateNow + '.csv';

	            this.CockpitService.getCSVCQRelevance().then(function (content) {
	                _this5.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	            });
	        }
	    }, {
	        key: 'downloadCSVControlQualityInfra',
	        value: function downloadCSVControlQualityInfra() {
	            var _this6 = this;

	            var filename = 'cockpit_infra_' + this.dateNow + '.csv';

	            this.CockpitService.getCSVCQInfra().then(function (content) {
	                _this6.CreateFileService.createAndDownloadFile(content, 'text/csv;', filename);
	            });
	        }
	    }]);

	    return CockpitController;
	})();

	exports.CockpitController = CockpitController;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var FormDialogController = (function () {
	    FormDialogController.$inject = ["$state", "$scope", "$mdDialog", "moment"];
	    function FormDialogController($state, $scope, $mdDialog, moment) {
	        'ngInject';

	        _classCallCheck(this, FormDialogController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.dialog = $mdDialog;
	        this.moment = moment;
	        this.disabled = true;
	        this.dateNowMinusOneMonth = this.moment().subtract(1, 'M').format('YYYY-MM-DD');
	        this.dateNow = this.moment().format('YYYY-MM-DD');
	        this.dataForm = {
	            'dtStart': this.dateNowMinusOneMonth,
	            'dtEnd': this.dateNow
	        };
	        this.regex = '[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])';
	    }

	    _createClass(FormDialogController, [{
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.dataForm);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return FormDialogController;
	})();

	exports.FormDialogController = FormDialogController;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var MdPaginationController = (function () {
	    MdPaginationController.$inject = ["$state", "$scope"];
	    function MdPaginationController($state, $scope) {
	        'ngInject';

	        _classCallCheck(this, MdPaginationController);

	        this.$state = $state;
	        this.$scope = $scope;

	        this.activate();
	    }

	    _createClass(MdPaginationController, [{
	        key: 'activate',
	        value: function activate() {
	            var _this = this;

	            this.$scope.$watch('pagination.total', function () {
	                _this.getPageNumber();
	            });
	        }
	    }, {
	        key: 'getPageNumber',
	        value: function getPageNumber() {
	            this.pageNumber = Math.ceil(this.total / this.perPage);
	            this.pagine();
	        }
	    }, {
	        key: 'pagine',
	        value: function pagine() {
	            this.pagination = [];
	            for (var i = 0; i < this.pageNumber; i++) {
	                var page = {};
	                page.id = i;
	                page.number = i + 1;
	                if (this.total < this.perPage) {
	                    page.end = this.total;
	                    page.start = 1;
	                } else {
	                    if ((i + 1) * this.perPage > this.total) {
	                        page.end = this.total;
	                    } else {
	                        page.end = (i + 1) * this.perPage;
	                    }
	                    page.start = page.end - this.perPage + 1;
	                }
	                this.pagination.push(page);
	            }
	            this.getCurrentPageInfo();
	        }
	    }, {
	        key: 'getCurrentPageInfo',
	        value: function getCurrentPageInfo() {
	            this.currentPage = _.find(this.pagination, { 'number': this.page });
	        }
	    }, {
	        key: 'nextPage',
	        value: function nextPage() {
	            this.page = this.page + 1;
	            this.getCurrentPageInfo();
	        }
	    }, {
	        key: 'prevPage',
	        value: function prevPage() {
	            this.page = this.page - 1;
	            this.getCurrentPageInfo();
	        }
	    }]);

	    return MdPaginationController;
	})();

	exports.MdPaginationController = MdPaginationController;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';

	GridListController.$inject = ["$log", "$mdDialog", "toastr", "GridService", "$scope"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GridListController = GridListController;

	function GridListController($log, $mdDialog, toastr, GridService, $scope) {
	    'ngInject';

	    var _this = this;

	    var $parent = $scope.$parent.ctrl;

	    this.grids = [];
	    this.search = '';
	    this.showSearch = false;

	    this.hasColumn = function (name) {
	        return $parent.columns.indexOf(name) !== -1;
	    };

	    this.hasActions = function () {
	        return $parent.actions.length > 0;
	    };

	    this.hasAction = function (name) {
	        return $parent.actions.indexOf(name) !== -1;
	    };

	    this.showDeleteModal = function (grid) {
	        var confirm = $mdDialog.confirm().title('Suppression').textContent($parent.getDeleteConfirmationText(grid)).clickOutsideToClose(true).ok('Confirmer').cancel('Annuler');

	        $mdDialog.show(confirm).then(function () {
	            _this.deleteGrid(grid);
	        });
	    };

	    this.getGrids = function () {
	        GridService.getNewGrids($parent.gridType).then(function (grids) {
	            _this.grids = grids.map(function (grid) {
	                return $parent.transformGrid(grid);
	            });
	        }, function (error) {
	            toastr.error('Impossible de récupérer les grilles');
	            $log.debug(error);
	        });
	    };

	    this.activate = function () {
	        $scope.$on($parent.eventName, function () {
	            if (_this.grids.length > 0) {
	                return false;
	            }

	            _this.getGrids();
	        });
	    };

	    this.deleteGrid = function (grid) {
	        $parent.deleteGridPromise(grid).then(function () {
	            toastr.success('La grille a bien été supprimée');
	            _this.getGrids();
	        }, function (error) {
	            toastr.error('Impossible de supprimer la grille');
	            $log.debug(error);
	        });
	    };

	    this.resetPagination = function () {
	        _this.page = 1;
	    };

	    this.toggleSearch = function () {
	        if (_this.search !== '') {
	            _this.search = '';
	        }

	        _this.showSearch = !_this.showSearch;
	        _this.resetPagination();
	    };

	    this.getEditionLink = function (item) {
	        return $parent.getEditionLink(item);
	    };

	    this.activate();
	}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';

	GridFormController.$inject = ["$scope", "$state", "$stateParams", "$log", "$mdDialog", "toastr", "GridService", "icons"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GridFormController = GridFormController;

	function GridFormController($scope, $state, $stateParams, $log, $mdDialog, toastr, GridService, icons) {
	    'ngInject';

	    var _this = this;

	    var $parent = $scope.$parent.ctrl;

	    this.gridType = $parent.gridType;
	    this.canAddCorrection = $parent.canAddCorrection;
	    this.title = ($stateParams.id ? 'Édition' : 'Création') + ' d\'une grille ' + this.gridType;

	    this.icons = icons;

	    this.hasAffectation = function (affectation) {
	        return $parent.affectations.indexOf(affectation) !== -1;
	    };

	    this.activate = function () {
	        if ($stateParams.id) {
	            _this.getGrid($stateParams.id);
	        } else {
	            _this.grid = {
	                name: '',
	                element_templates: [],
	                failing_element_templates: [],
	                types: null,
	                sites: null
	            };
	        }
	    };

	    this.getGrid = function (id) {
	        GridService.getAreaTemplate(id).then(function (data) {
	            data.types = data['site_type_area_templates'].map(function (stat) {
	                return stat['site_type'].id;
	            });
	            data.sites = data['site_area_templates'].map(function (sat) {
	                return sat.site.id;
	            });

	            if (data.sites.length === 0) {
	                delete data.sites;
	            }

	            if (data.types.length === 0) {
	                delete data.types;
	            }

	            $parent.cleanGrid(data);
	            _this.grid = data;
	            $scope.$broadcast('gridLoaded');
	        }, function (error) {
	            toastr.error('Impossible de récupérer la grille');
	            $log.debug(error);
	        });
	    };

	    this.saveGrid = function () {
	        var grid = Object.assign({}, _this.grid);

	        delete grid['site_type_area_templates'];
	        delete grid['site_area_templates'];

	        if ($stateParams.id) {
	            _this.updateGrid($stateParams.id, grid);
	        } else {
	            _this.createGrid(grid);
	        }
	    };

	    this.updateGrid = function (gridId, grid) {
	        GridService.updateGrid(gridId, grid).then(function () {
	            toastr.success('La grille a bien été modifiée');
	            _this.close();
	        }, function (error) {
	            toastr.error('Impossible d\'enregistrer la grille');
	            $log.debug(error);
	        });
	    };

	    this.createGrid = function (grid) {
	        GridService.saveNewGrid(grid).then(function () {
	            toastr.success('La nouvelle grille a bien été enregistrée');
	            _this.close();
	        }, function (error) {
	            toastr.error('Impossible d\'enregistrer la nouvelle grille');
	            $log.debug(error);
	        });
	    };

	    this.close = function () {
	        if ($stateParams.from) {
	            $state.go('root.view.site', { id: $stateParams.from });
	        } else {
	            $state.go('root.view.dashboard', { currentTab: parseInt(_this.tab) });
	        }
	    };

	    this.activate();
	}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';

	GridAffectationsController.$inject = ["$scope", "toastr", "$log", "SiteService"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GridAffectationsController = GridAffectationsController;

	function GridAffectationsController($scope, toastr, $log, SiteService) {
	    'ngInject';

	    var _this = this;

	    var $parent = $scope.$parent.ctrl;

	    this.hasSwitch = $parent.hasAffectation('sites') && $parent.hasAffectation('types');
	    this['switch'] = false;
	    this.affectation = { type: 1 };
	    this.sitesTableOptions = { limit: 10, page: 1 };
	    this.typesTableOptions = { limit: 10, page: 1 };
	    this.sitesQuery = '';
	    this.typesQuery = '';
	    this.showSitesSearch = false;

	    this.activate = function () {
	        if ($parent.hasAffectation('sites')) {
	            _this.getSites();
	            _this.affectation.type = 2;
	        }

	        if ($parent.hasAffectation('types')) {
	            _this.getSiteTypes();
	            _this.affectation.type = 1;
	        }
	    };

	    // Affectation
	    this.isAffected = function (choice) {
	        if (angular.isUndefined($parent.grid)) {
	            return;
	        }

	        if (choice === 'type') {
	            _.forEach($parent.grid.types, function (type) {
	                var item = _.find(_this.siteTypes, { id: type });
	                item.check = true;
	            });
	        }

	        if (choice === 'site') {
	            _.forEach($parent.grid.sites, function (site) {
	                var item = _.find(_this.sites, { id: site });
	                if (item) {
	                    item.check = true;
	                }
	            });
	        }
	    };

	    this.switchAffectation = function () {
	        if (_this['switch']) {
	            _this.affectation.type = 1;
	            $parent.grid.types = [];
	            delete $parent.grid.sites;
	            _this.isAffected('type');
	        } else {
	            _this.affectation.type = 2;
	            $parent.grid.sites = [];
	            delete $parent.grid.types;
	            _this.isAffected('site');
	        }
	    };

	    this.toggleAffectation = function (elem) {
	        if (_this.affectation.type === 1) {
	            if (angular.isUndefined($parent.grid.types) || $parent.grid.types === null) {
	                $parent.grid.types = [elem.id];
	            } else if ($parent.grid.types.indexOf(elem.id) !== -1) {
	                var index = $parent.grid.types.indexOf(elem.id);
	                $parent.grid.types.splice(index, 1);
	            } else {
	                $parent.grid.types.push(elem.id);
	            }
	        }

	        if (_this.affectation.type === 2) {
	            if (angular.isUndefined($parent.grid.sites) || $parent.grid.sites === null) {
	                $parent.grid.sites = [elem.id];
	            } else if ($parent.grid.sites.indexOf(elem.id) !== -1) {
	                var index = $parent.grid.sites.indexOf(elem.id);
	                $parent.grid.sites.splice(index, 1);
	            } else {
	                $parent.grid.sites.push(elem.id);
	            }
	        }
	    };

	    this.getSiteTypes = function () {
	        SiteService.getSiteTypes().then(function (data) {
	            _this.siteTypes = data;
	            _this.isAffected('type');
	        }, function (error) {
	            toastr.error('Impossible de récupérer les types de site');
	            $log.debug(error);
	        });
	    };

	    this.getSites = function () {
	        SiteService.getSites().then(function (data) {
	            _this.sites = data;
	            _this.isAffected('site');
	        }, function (error) {
	            toastr.error('Impossible de récupérer les sites');
	            $log.debug(error);
	        });
	    };

	    this.resetSitesPagination = function () {
	        _this.sitesTableOptions.page = 1;
	    };

	    this.toggleSitesSearch = function () {
	        if (_this.sitesQuery != '') {
	            _this.sitesQuery = '';
	        }
	        _this.showSitesSearch = !_this.showSitesSearch;
	        _this.sitesTableOptions.page = 1;
	    };

	    this.activate();

	    $scope.$on('gridLoaded', function () {
	        _this.isAffected('site');
	        _this.isAffected('type');
	    });
	}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';

	GridElementsController.$inject = ["$scope", "$mdDialog", "$log"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GridElementsController = GridElementsController;

	function GridElementsController($scope, $mdDialog, $log) {
	    'ngInject';

	    var _this = this;

	    this.$parent = $scope.$parent.ctrl;

	    this.editItemId = null;
	    this.newDeficientElem = {};
	    this.requiredControlName = false;
	    this.requiredControldesc = false;
	    this.deficientElemNameRequired = false;
	    this.newControlPoint = {
	        coefficient: 1,
	        fix_element_templates: []
	    };
	    this.newDeficientElem = {};
	    this.canAddCorrection = this.$parent.canAddCorrection;

	    // Control Points
	    this.addControlPoint = function () {
	        _this.requiredControlName = false;
	        _this.requiredControlDesc = false;
	        if (angular.isUndefined(_this.newControlPoint.name) || angular.isUndefined(_this.newControlPoint.criteria)) {
	            if (angular.isUndefined(_this.newControlPoint.name)) {
	                _this.requiredControlName = true;
	            }
	            if (angular.isUndefined(_this.newControlPoint.criteria)) {
	                _this.requiredControlDesc = true;
	            }
	        } else {
	            _this.$parent.grid.element_templates.push(_this.newControlPoint);
	            _this.newControlPoint = null;
	        }
	    };

	    this.editControlPoint = function (index) {
	        _this.editItemId = index;
	    };

	    this.validEditControlPoint = function () {
	        _this.editItemId = null;
	    };

	    this.removeControlPoint = function (point) {
	        _this.$parent.grid.element_templates = _.filter(_this.$parent.grid.element_templates, function (item) {
	            if (item.name !== point.name) {
	                return item;
	            }
	        });
	    };

	    this.addCorrectivesActionsModal = function (point) {
	        var modalTemplate = $mdDialog.confirm({
	            templateUrl: 'app/views/content/dashboard/action/corrective/form.html',
	            clickOutsideToClose: true,
	            controller: 'ActionCorrectiveFormController',
	            controllerAs: 'ctrl',
	            fullscreen: true,
	            locals: {
	                point: point
	            }
	        });

	        $mdDialog.show(modalTemplate).then(function (data) {
	            if (data.type === 'add') {
	                $log.debug(data);
	                _this.newControlPoint.fix_element_templates = data.data.fix_element_templates;
	            }
	            if (data.type === 'edit') {
	                $log.debug(data);
	            }
	        });
	    };

	    //Deficient elements
	    this.addDeficientElem = function () {
	        if (angular.isUndefined(_this.newDeficientElem.name)) {
	            _this.deficientElemNameRequired = true;
	        } else {
	            _this.deficientElemNameRequired = false;
	            _this.$parent.grid.failing_element_templates.push(_this.newDeficientElem);
	            _this.newDeficientElem = {};
	        }
	    };

	    this.removeDeficientElem = function (elem) {
	        _this.$parent.grid.failing_element_templates = _.filter(_this.$parent.grid.failing_element_templates, function (e) {
	            if (e.name !== elem.name) {
	                return e;
	            }
	        });
	    };
	}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';

	GridListsController.$inject = ["$scope"];
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.GridListsController = GridListsController;

	function GridListsController($scope) {
	    'ngInject';

	    var _this = this;

	    this.siteSearch = '';
	    this.typeSearch = '';

	    this.showSiteSearch = false;
	    this.showTypeSearch = false;

	    this.sitePagination = {
	        limit: 10,
	        page: 1
	    };

	    this.typePagination = {
	        limit: 10,
	        page: 1
	    };

	    this.activate = function () {
	        _this.sites = $scope.$parent.ctrl.grid['site_area_templates'].filter(function (element) {
	            return !element.site['deleted_at'];
	        });
	        _this.types = $scope.$parent.ctrl.grid['site_type_area_templates'];
	        _this.sitePagination.count = _this.sites.length;
	        _this.typePagination.count = _this.types.length;
	    };

	    this.onSitePagination = function (page, limit) {
	        _this.sitePagination.page = page;
	        _this.sitePagination.limit = limit;
	    };

	    this.onTypePagination = function (page, limit) {
	        _this.typePagination.page = page;
	        _this.typePagination.limit = limit;
	    };

	    this.resetSitePagination = function () {
	        _this.sitePagination.page = 1;
	    };

	    this.resetTypePagination = function () {
	        _this.typePagination.page = 1;
	    };

	    this.toggleSiteSearch = function () {
	        if (_this.siteSearch !== '') {
	            _this.siteSearch = '';
	        }

	        _this.showSiteSearch = !_this.showSiteSearch;
	        _this.resetSitePagination();
	    };

	    this.toggleTypeSearch = function () {
	        if (_this.typeSearch !== '') {
	            _this.typeSearch = '';
	        }

	        _this.showTypeSearch = !_this.showTypeSearch;
	        _this.resetTypePagination();
	    };

	    $scope.$on('gridLoaded', function () {
	        _this.activate();
	    });
	}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.UserInfosDirective = UserInfosDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function UserInfosDirective() {
	    'ngInject';

	    var directive = {
	        restrict: 'E',
	        templateUrl: 'app/components/userInfos/userInfos.html',
	        controller: UserInfosController,
	        controllerAs: 'userinfos',
	        bindToController: true
	    };

	    return directive;
	}

	var UserInfosController = (function () {
	    function UserInfosController() {
	        'ngInject';

	        _classCallCheck(this, UserInfosController);

	        this.user = {
	            gender: 'M',
	            firstname: 'Dupré',
	            lastname: 'Jean-Pierre'
	        };

	        this.activate();
	    }

	    _createClass(UserInfosController, [{
	        key: 'activate',
	        value: function activate() {}
	    }]);

	    return UserInfosController;
	})();

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.MdPaginationDirective = MdPaginationDirective;

	function MdPaginationDirective() {
	    'ngInject';

	    var directive = {
	        restrict: 'E',
	        templateUrl: 'app/components/mdPagination/mdPagination.html',
	        controller: 'MdPaginationController',
	        controllerAs: 'pagination',
	        bindToController: true,
	        scope: {
	            total: '=',
	            paginate: '=',
	            data: '=',
	            from: '=',
	            perPage: '=',
	            page: '='
	        }
	    };

	    return directive;
	}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var GridList = {
	    templateUrl: 'app/components/grid/list.html',
	    bindings: {
	        sort: '@',
	        limit: '@',
	        page: '@',
	        title: '@'
	    },
	    controller: 'GridListController',
	    controllerAs: 'table'
	};
	exports.GridList = GridList;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var GridForm = {
	    templateUrl: 'app/components/grid/form.html',
	    bindings: {
	        tab: '@'
	    },
	    controller: 'GridFormController',
	    controllerAs: 'ctrl'
	};
	exports.GridForm = GridForm;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditUserSecondaryAgenciesController = (function () {
	    EditUserSecondaryAgenciesController.$inject = ["$state", "$scope", "user", "roles", "agencies", "userAgencies", "$mdDialog"];
	    function EditUserSecondaryAgenciesController($state, $scope, user, roles, agencies, userAgencies, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, EditUserSecondaryAgenciesController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.user = user;
	        this.roles = roles;
	        this.agencies = agencies;
	        this.userAgencies = userAgencies;
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.activate();
	    }

	    _createClass(EditUserSecondaryAgenciesController, [{
	        key: 'isAgencyCheckboxChecked',
	        value: function isAgencyCheckboxChecked(agency) {
	            return this.isUserMainAgency(agency) || this.userAgencies.find(function (secondaryAgencies) {
	                return secondaryAgencies.id === agency.id;
	            });
	        }
	    }, {
	        key: 'toggleAgencyCheckbox',
	        value: function toggleAgencyCheckbox(agency) {
	            if (this.isAgencyCheckboxChecked(agency)) {
	                this.userAgencies = this.userAgencies.filter(function (secondaryAgencies) {
	                    return secondaryAgencies.id !== agency.id;
	                });
	            } else {
	                this.userAgencies.push(agency);
	            }
	        }
	    }, {
	        key: 'isAgencyCheckboxDisabled',
	        value: function isAgencyCheckboxDisabled(agency) {
	            return this.isUserMainAgency(agency);
	        }
	    }, {
	        key: 'isUserMainAgency',
	        value: function isUserMainAgency(agency) {
	            return this.user.agency.id === agency.id;
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            // WARNING empty method
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide({
	                role: this.user.roles[0],
	                secondaryAgencies: this.userAgencies.map(function (secondaryAgency) {
	                    return secondaryAgency.id;
	                })
	            });
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditUserSecondaryAgenciesController;
	})();

	exports.EditUserSecondaryAgenciesController = EditUserSecondaryAgenciesController;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomerSpecificService = (function () {
	    CustomerSpecificService.$inject = ["$log", "$q", "$timeout", "Restangular", "$http"];
	    function CustomerSpecificService($log, $q, $timeout, Restangular, $http) {
	        'ngInject';

	        _classCallCheck(this, CustomerSpecificService);

	        this.$log = $log;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	        this.$http = $http;
	    }

	    // services

	    _createClass(CustomerSpecificService, [{
	        key: 'getCustomersSpecific',
	        value: function getCustomersSpecific() {
	            return this.restangular.one('customer-specifics/').get();
	        }
	    }, {
	        key: 'getCustomersSpecificSite',
	        value: function getCustomersSpecificSite(id) {
	            return this.restangular.one('customer-specifics/', id).one('sites-id').get();
	        }
	    }, {
	        key: 'getCustomersSpecificAlias',
	        value: function getCustomersSpecificAlias(id) {
	            return this.restangular.one('customer-specifics/', id).one('sites-alias').get();
	        }
	    }, {
	        key: 'addCustomerSpecific',
	        value: function addCustomerSpecific(data) {
	            return this.restangular.one('customer-specifics/').post('', data);
	        }
	    }, {
	        key: 'duplicateCustomerSpecific',
	        value: function duplicateCustomerSpecific(id, data) {
	            return this.restangular.one('customer-specifics/', id).post('duplicate', data);
	        }
	    }, {
	        key: 'sendPasswordCustomerSpecific',
	        value: function sendPasswordCustomerSpecific(id) {
	            return this.restangular.one('customer-specifics/', id).post('send-password');
	        }
	    }, {
	        key: 'updateCustomerSpecific',
	        value: function updateCustomerSpecific(id, customerSpecific) {
	            return this.restangular.one('customer-specifics/', id).patch(customerSpecific);
	        }
	    }, {
	        key: 'deleteCustomerSpecific',
	        value: function deleteCustomerSpecific(id) {
	            return this.restangular.one('customer-specifics', id).remove();
	        }
	    }]);

	    return CustomerSpecificService;
	})();

	exports.CustomerSpecificService = CustomerSpecificService;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var CustomerSpecificFormController = (function () {
	    CustomerSpecificFormController.$inject = ["customerSpecific", "$mdDialog"];
	    function CustomerSpecificFormController(customerSpecific, $mdDialog) {
	        'ngInject';

	        _classCallCheck(this, CustomerSpecificFormController);

	        this.customerSpecific = customerSpecific;
	        this.dialog = $mdDialog;
	        this.civilities = [{ id: 1, label: 'Mr' }, { id: 2, label: 'Mme' }];
	        this.search = '';
	        this.activate();
	    }

	    _createClass(CustomerSpecificFormController, [{
	        key: 'activate',
	        value: function activate() {}
	    }, {
	        key: 'getCivility',
	        value: function getCivility(id) {
	            return this.civilities.find(function (civility) {
	                return civility.id === id;
	            }).label;
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide(this.customerSpecific);
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return CustomerSpecificFormController;
	})();

	exports.CustomerSpecificFormController = CustomerSpecificFormController;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditCustomerSpecificSiteController = (function () {
	    EditCustomerSpecificSiteController.$inject = ["customerSpecific", "sites", "toastr", "$log", "$mdDialog", "CustomerSpecificService"];
	    function EditCustomerSpecificSiteController(customerSpecific, sites, toastr, $log, $mdDialog, CustomerSpecificService) {
	        'ngInject';

	        _classCallCheck(this, EditCustomerSpecificSiteController);

	        this.customerSpecific = customerSpecific;
	        this.CustomerSpecificService = CustomerSpecificService;
	        this.sites = [].concat(_toConsumableArray(sites));
	        this.dialog = $mdDialog;
	        this.toastr = toastr;
	        this.$log = $log;
	        this.search = '';
	        this.civilities = [{ id: 1, label: 'Mr' }, { id: 2, label: 'Mme' }];

	        this.tableOptions = { limit: 9, page: 1 };
	        this.selected = [];
	        this.aliases = {};

	        this.activate();
	    }

	    _createClass(EditCustomerSpecificSiteController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getSelectedSites();
	            this.getAliasSites();
	        }
	    }, {
	        key: 'getCivility',
	        value: function getCivility(id) {
	            return this.civilities.find(function (civility) {
	                return civility.id === id;
	            }).label;
	        }
	    }, {
	        key: 'resetSearch',
	        value: function resetSearch() {
	            this.search = '';
	        }
	    }, {
	        key: 'getSelectedSites',
	        value: function getSelectedSites() {
	            var _this = this;

	            this.CustomerSpecificService.getCustomersSpecificSite(this.customerSpecific.id).then(function (success) {
	                _this.selected = [].concat(_toConsumableArray(success));
	                _this.sites.forEach(function (site) {
	                    site.selected = success.indexOf(site.id) >= 0;
	                });
	                _this.sites.sort(function (site) {
	                    return site.selected ? -1 : 1;
	                });
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des sites selectionne');
	                _this.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'getAliasSites',
	        value: function getAliasSites() {
	            var _this2 = this;

	            this.CustomerSpecificService.getCustomersSpecificAlias(this.customerSpecific.id).then(function (success) {
	                _this2.siteAlias = Object.assign({}, success.plain());
	                var siteAlias = Object.assign({}, _this2.siteAlias);
	                _this2.sites.forEach(function (site) {
	                    site.alias = siteAlias[site.id] ? siteAlias[site.id] : '';
	                });
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer la liste des alias');
	                _this2.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'isChecked',
	        value: function isChecked(site) {
	            return this.selected.includes(site.id);
	        }
	    }, {
	        key: 'toggleCheck',
	        value: function toggleCheck(site) {
	            site.selected = !site.selected;
	            this.updateSelected(site);
	        }
	    }, {
	        key: 'resetPagination',
	        value: function resetPagination() {
	            this.tableOptions.page = 1;
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide({
	                sites: this.selected,
	                sitesAlias: this.siteAlias
	            });
	        }
	    }, {
	        key: 'updateAlias',
	        value: function updateAlias(site) {
	            this.siteAlias[site.id] = site.alias;
	        }
	    }, {
	        key: 'updateSelected',
	        value: function updateSelected(site) {
	            var siteIdx = this.selected.indexOf(site.id);
	            siteIdx === -1 ? this.selected.push(site.id) : this.selected.splice(siteIdx, 1);
	        }
	    }, {
	        key: 'selectAll',
	        value: function selectAll(sitesList) {
	            var _this3 = this;

	            sitesList.forEach(function (site) {
	                var siteIdx = _this3.selected.indexOf(site.id);
	                if (siteIdx < 0) {
	                    site.selected = true;
	                    _this3.selected.push(site.id);
	                }
	            });
	        }
	    }, {
	        key: 'deselectAll',
	        value: function deselectAll(sitesList) {
	            var _this4 = this;

	            sitesList.forEach(function (site) {
	                var siteIdx = _this4.selected.indexOf(site.id);
	                if (siteIdx >= 0) {
	                    site.selected = false;
	                    _this4.selected.splice(siteIdx, 1);
	                }
	            });
	        }
	    }, {
	        key: 'filter',
	        value: function filter(query) {
	            var lowerCaseQuery = query ? query.toLowerCase() : '';
	            return function (value) {
	                var q = lowerCaseQuery;

	                return value.name && value.name.toLowerCase().includes(lowerCaseQuery) || value.quadra_id && value.quadra_id.toLowerCase().includes(lowerCaseQuery) || value.alias && value.alias.toLowerCase().includes(lowerCaseQuery) || value.customer && value.customer.name && value.customer.name.toLowerCase().includes(lowerCaseQuery);
	            };
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditCustomerSpecificSiteController;
	})();

	exports.EditCustomerSpecificSiteController = EditCustomerSpecificSiteController;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DefaultPopInController = (function () {
	    DefaultPopInController.$inject = ["$scope", "$mdDialog", "locals"];
	    function DefaultPopInController($scope, $mdDialog, locals) {
	        'ngInject';

	        _classCallCheck(this, DefaultPopInController);

	        this.title = locals.title;
	        this.content = locals.content;
	        this.ok = locals.ok || "Valider";
	        this.cancel = locals.cancel || "Annuler";

	        this.dialog = $mdDialog;
	    }

	    _createClass(DefaultPopInController, [{
	        key: "validDialog",
	        value: function validDialog() {
	            this.dialog.hide();
	        }
	    }, {
	        key: "closeDialog",
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return DefaultPopInController;
	})();

	exports.DefaultPopInController = DefaultPopInController;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var EditManagerPlanningsAccessController = (function () {
	    EditManagerPlanningsAccessController.$inject = ["$state", "$scope", "user", "roles", "$mdDialog", "ManagerService"];
	    function EditManagerPlanningsAccessController($state, $scope, user, roles, $mdDialog, ManagerService) {
	        'ngInject';

	        _classCallCheck(this, EditManagerPlanningsAccessController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.user = user;
	        this.roles = roles;
	        this.managers = [];
	        this.managersAccessed = [];
	        this.dialog = $mdDialog;
	        this.disabled = false;
	        this.ManagerService = ManagerService;
	        this.activate();
	    }

	    _createClass(EditManagerPlanningsAccessController, [{
	        key: 'isManagerCheckboxChecked',
	        value: function isManagerCheckboxChecked(manager) {
	            return this.isUser(manager) || this.managersAccessed.find(function (secondaryManagers) {
	                return secondaryManagers.id === manager.id;
	            });
	        }
	    }, {
	        key: 'toggleManagerCheckbox',
	        value: function toggleManagerCheckbox(manager) {
	            if (this.isManagerCheckboxChecked(manager)) {
	                this.managersAccessed = this.managersAccessed.filter(function (secondaryManagers) {
	                    return secondaryManagers.id !== manager.id;
	                });
	            } else {
	                this.managersAccessed.push(manager);
	            }
	        }
	    }, {
	        key: 'isManagerCheckboxDisabled',
	        value: function isManagerCheckboxDisabled(manager) {
	            return this.isUser(manager);
	        }
	    }, {
	        key: 'isUser',
	        value: function isUser(manager) {
	            return this.user.id === manager.id;
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            this.getManagerRelatedManager();
	            this.getPlanningAccessed();
	            // WARNING empty method
	        }
	    }, {
	        key: 'getManagerRelatedManager',
	        value: function getManagerRelatedManager() {
	            var _this = this;

	            this.ManagerService.getManagerRelatedManager(this.user.id).then(function (managers) {
	                _this.managers = managers;
	            });
	        }
	    }, {
	        key: 'getPlanningAccessed',
	        value: function getPlanningAccessed() {
	            var _this2 = this;

	            this.ManagerService.getManagerAccessedPlanning(this.user.id).then(function (managerAccessed) {
	                _this2.managersAccessed = managerAccessed;
	            });
	        }
	    }, {
	        key: 'hasLastName',
	        value: function hasLastName(manager) {
	            return manager.last_name && manager.last_name.trim().length > 0;
	        }
	    }, {
	        key: 'validDialog',
	        value: function validDialog() {
	            this.dialog.hide({
	                role: this.user.roles[0],
	                managerPlanningAccess: this.managersAccessed.map(function (secondaryManager) {
	                    return secondaryManager.id;
	                })
	            });
	        }
	    }, {
	        key: 'closeDialog',
	        value: function closeDialog() {
	            this.dialog.cancel();
	        }
	    }]);

	    return EditManagerPlanningsAccessController;
	})();

	exports.EditManagerPlanningsAccessController = EditManagerPlanningsAccessController;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var ManagerService = (function () {
	    ManagerService.$inject = ["$log", "$q", "$timeout", "Restangular", "$http"];
	    function ManagerService($log, $q, $timeout, Restangular, $http) {
	        'ngInject';

	        _classCallCheck(this, ManagerService);

	        this.$log = $log;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.restangular = Restangular;
	        this.$http = $http;
	    }

	    // services

	    _createClass(ManagerService, [{
	        key: 'getManagerRelatedManager',
	        value: function getManagerRelatedManager(id) {
	            return this.restangular.one('manager/', id).one('related-managers').get();
	        }
	    }, {
	        key: 'getManagerAccessedPlanning',
	        value: function getManagerAccessedPlanning(id) {
	            return this.restangular.one('manager/', id).one('accessed-planning').get();
	        }
	    }, {
	        key: 'getActiveManagers',
	        value: function getActiveManagers() {
	            return this.restangular.one('manager').one('active').get();
	        }
	    }]);

	    return ManagerService;
	})();

	exports.ManagerService = ManagerService;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var ControlService = (function () {
	    ControlService.$inject = ["$log", "Restangular"];
	    function ControlService($log, Restangular) {
	        'ngInject';

	        _classCallCheck(this, ControlService);

	        this.$log = $log;
	        this.restangular = Restangular;
	    }

	    _createClass(ControlService, [{
	        key: 'searchControl',
	        value: function searchControl(id) {
	            return this.restangular.one('controls', id).one('editable').get();
	        }
	    }, {
	        key: 'updateControl',
	        value: function updateControl(id, data) {
	            return this.restangular.one('controls', id).patch(data);
	        }
	    }, {
	        key: 'duplicateControl',
	        value: function duplicateControl(id, data) {
	            return this.restangular.one('controls', id).one('duplicate').post('', data);
	        }
	    }]);

	    return ControlService;
	})();

	exports.ControlService = ControlService;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var ControlController = (function () {
	    ControlController.$inject = ["$log", "moment", "toastr", "ControlService", "ManagerService", "SiteService"];
	    function ControlController($log, moment, toastr, ControlService, ManagerService, SiteService) {
	        'ngInject';

	        _classCallCheck(this, ControlController);

	        this.$log = $log;
	        this.moment = moment;
	        this.toastr = toastr;
	        this.ControlService = ControlService;
	        this.ManagerService = ManagerService;
	        this.SiteService = SiteService;

	        this.dateRegex = '[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) ([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]';
	        this.searchId = '';
	        this.control = null;
	        this.notFound = false;
	        this.locked = false;
	        this.action = 'update';

	        this.activate();
	    }

	    _createClass(ControlController, [{
	        key: 'activate',
	        value: function activate() {
	            this.getActiveManagers();
	            this.getActiveSites();
	        }
	    }, {
	        key: 'getActiveManagers',
	        value: function getActiveManagers() {
	            var _this = this;

	            this.ManagerService.getActiveManagers().then(function (success) {
	                _this.managers = success;
	            }, function (error) {
	                _this.toastr.error('Impossible de récupérer la liste des managers');
	                _this.$log.error(error);
	            });
	        }
	    }, {
	        key: 'getActiveSites',
	        value: function getActiveSites() {
	            var _this2 = this;

	            this.SiteService.getActiveSites().then(function (success) {
	                _this2.sites = success;
	            }, function (error) {
	                _this2.toastr.error('Impossible de récupérer la liste des sites');
	                _this2.$log.error(error);
	            });
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            var _this3 = this;

	            this.control = null;
	            this.notFound = false;
	            this.locked = false;

	            this.ControlService.searchControl(this.searchId).then(function (success) {
	                _this3.control = success;
	                _this3.resetEditForm();
	            }, function (error) {
	                _this3.notFound = true;
	                _this3.$log.debug(error);
	            });
	        }
	    }, {
	        key: 'resetEditForm',
	        value: function resetEditForm() {
	            var now = this.moment().format('YYYY-MM-DD HH:mm:ss');

	            this.action = 'update';
	            this.editForm = {
	                created_at: now,
	                validated_at: now,
	                site: this.control.site_id,
	                user: this.control.manager_id
	            };
	        }
	    }, {
	        key: 'execute',
	        value: function execute() {
	            var _this4 = this;

	            var promise = this.action === 'duplicate' ? this.ControlService.duplicateControl(this.control.id, this.editForm) : this.ControlService.updateControl(this.control.id, this.editForm);

	            promise.then(function () {
	                _this4.toastr.success(_this4.action === 'duplicate' ? 'Le contrôle a bien été dupliqué' : 'Le contrôle a bien été modifié');
	                _this4.locked = true;
	            }, function (error) {
	                _this4.toastr.error('Impossible d\'exécuter cette action sur le contrôle');
	                _this4.$log.error(error);
	            });
	        }
	    }]);

	    return ControlController;
	})();

	exports.ControlController = ControlController;

/***/ })
/******/ ]);